<head>
  <title> Main Reports</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row ps-0">
  <div class="col-md-12">
    <app-breadcrumb></app-breadcrumb>
    <div class="row">
      <div class="col-md-3">
        <div><label for="email" id="orgNameAlert">Organization<span class="mandatory-symbol">*</span> : </label></div>
        <mat-select matInput multiple placeholder="Select" #orgVal [(ngModel)]="selectedOrgValue"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')"
          (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText" matInput placeholder="search">
          <mat-option *ngFor="let item of orgValueDropdown | multiAssessmentSearchPipe : departmentSearchText"
            [value]="item.valueExp" (onSelectionChange)="onOrgsSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-md-2" *ngIf="selectedOrgValue.length>0">
        <div><label for="email" id="reportType">Module</label><span class="mandatory-symbol">*</span> :</div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportType" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onReportTypeSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of drpodownValReportType | assessmentSearch : groupSearchText"
            (onSelectionChange)="onReportTypeSelect($event,item)" [value]="item">
            {{ item}}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-2" *ngIf="selectedReportType=='Quality'">
        <div><label for="email" id="typeReport">Type</label><span class="mandatory-symbol">*</span> :</div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedType" (closed)="typeSearchText=''">
          <mat-option *ngFor="let item of activityOrActionList | assessmentSearch : typeSearchText"
            (onSelectionChange)="onTypeSelect($event,item)" [value]="item">
            {{ item}}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-md-2" *ngIf="selectedReportType=='Quality'">
        <div><label for="email" id="module">Quality Modules</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedModule" (closed)="groupSearchText1=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText1"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
          <mat-option *ngFor="let item of moduleValueDropdown | assessmentSearch : groupSearchText1"
            (onSelectionChange)="onModulesSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-md-2" *ngIf="selectedReportType=='Quality' && selectedOrgValue.length>0">
        <div><label for="email" id="groupAlert">Group : </label></div>
        <mat-select matInput multiple placeholder="Select" #qmsGroupVal [(ngModel)]="selectedQmsGroup"
          (closed)="qmsGroupSearchText=''" (click)="focusSearch('focus-qmsGroup-search')"
          (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-qmsGroup-search" class="dropdownsearchstyle" [(ngModel)]="qmsGroupSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="qmsGroupSelection" (change)="toggleAllSelectionForGroup()">
              Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of qmsGroupValueDropdown | multiAssessmentSearchPipe : qmsGroupSearchText"
            [value]="item.valueExp" (onSelectionChange)="onQmsGroupSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3" *ngIf="selectedReportType=='Quality' && selectedOrgValue.length>0">
        <div><label for="email" id="DeptAlert">Department : </label></div>
        <mat-select matInput multiple placeholder="Select" #qmsDeptVal [(ngModel)]="selectedQmsDept"
          (closed)="qmsDepartmentSearchText=''" (click)="focusSearch('focus-qmsDept-search')"
          (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-qmsDept-search" class="dropdownsearchstyle"
            [(ngModel)]="qmsDepartmentSearchText" matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="qmsDeptSelection" (change)="toggleAllSelectionForDept()">
              Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of qmsDeptValueDropdown | multiAssessmentSearchPipe : qmsDepartmentSearchText"
            [value]="item.valueExp" (onSelectionChange)="onQmsDeptSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-1"
        *ngIf="selectedReportType=='Quality' && selectedType=='Activity' && selectedOrgValue.length>0">
        <div>
          <label for="email"><b>Show in % </b></label>
        </div>
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="showPercentage" (change)="showPercentagFun($event)">
            <span class="active-inActive-container" *ngIf="showPercentage" style="color: green;">Yes</span>
            <span *ngIf="!showPercentage" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-2" *ngIf="selectedReportType=='Quality' && selectedOrgValue.length>0">
        <div>
          <label for="email"><b> Specify Interval</b></label>
        </div>
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="specificIntervalVal" (change)="specificIntervalFun($event)">
            <span class="active-inActive-container" *ngIf="specificIntervalVal" style="color: green;">Yes</span>
            <span *ngIf="!specificIntervalVal" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-2" *ngIf="selectedReportType=='Quality' && specificIntervalVal">
        <label for="email" id="fromDateAlert">From Date <span class="mandatory-symbol">*</span>: </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate"
          (ngModelChange)="onNgModelChange($event,'fromDateAlert')">
      </div>
      <div class="col-md-2" *ngIf="selectedReportType=='Quality' && specificIntervalVal">
        <label for="email" id="toDateAlert">To Date <span class="mandatory-symbol">*</span>: </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate"
          (ngModelChange)="onNgModelChange($event,'toDateAlert')">
      </div>
      <div class="col-md-2" *ngIf="selectedReportType=='Quality' && specificIntervalVal">
        <div><label for="email">Interval : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedIntervalValue" (closed)="groupSearchText2=''"
          (click)="focusSearch('focus-interval-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-interval-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText2"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
          <mat-option *ngFor="let item of intervalValueDropdown | assessmentSearch : groupSearchText2"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col-md-3" *ngIf="selectedReportType=='Trainings' && selectedOrgValue.length>0">
        <label for="email" id="manageReportNameAlert"> <b> Report Name <span class="mandatory-symbol"
              *ngIf="selectedOrgValue.length === 1">*</span>
            &nbsp;: &nbsp; </b></label>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByReportCodeMain" (closed)="groupSearchText3=''"
          (click)="focusSearch('focus-report-name-search')" (keydown.enter)="focusSearch('focus-Logo-search')">

          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onReportTypeSelectnew($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of reportListDropdown | assessmentSearch : groupSearchText3;"
            (onSelectionChange)="onReportTypeSelectnew($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4" style=" justify-content: left "
        *ngIf="selectedReportType=='Trainings' && selectedOption=='Training Groups' && selectedOrgValue.length>0">
        <label for="email" id="groupNameAlert" style="margin-top: 10px;">Group <span
            class="mandatory-symbol">*</span>&nbsp;: &nbsp;</label>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroup" (closed)="groupSearchText4=''"
          (click)="focusSearch('focus-group-search6')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-group-search6" class="dropdownsearchstyle" [(ngModel)]="groupSearchText4"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onGroupSelectnew($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText4;"
            (onSelectionChange)="onGroupSelectnew($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-1" style="position: relative;"
        *ngIf="selectedOption=='Instructor Trainings' && selectedReportType=='Trainings' && selectedOrgValue.length>0">
        <label for=" "><b> Show Trainer</b></label>
        <br>
        <div>
          <input type="checkbox" style="zoom: 1.2;margin-top: 3px;margin-left: 51px;" [checked]="showTrainerLevel"
            (change)="showTrainerLevelFcn($event)">
        </div>
      </div>
      <div class="col-md-3"
        *ngIf="showTrainerLevel==false && selectedOption=='Instructor Trainings' && selectedReportType=='Trainings' && selectedOrgValue.length>0">
        <label for="email" id="instructorTrainingNameAlert"><b>Instructor Training Name : </b></label>
        <div style="display: flex; ">
          <div class="col-sm-7" style="position: relative;">
            <input id="participantUserName" style="cursor: not-allowed; height: 35px;" type="text"
              class="userNametextbox" [(ngModel)]="getSelectedInstructorTrainingName" disabled>
          </div>&nbsp;&nbsp;
          <div class="col-sm-1 search-icon" (click)="searchInstructorTrainingFunction()"
            (keydown.enter)="focusSearch('focus-Logo-search')" style="margin-top: 7px;">
            <i class="fa fa-search fa-1x"></i>
          </div>
        </div>
      </div>
      <div class="col-md-3"
        *ngIf="showTrainerLevel && selectedOption=='Instructor Trainings' && selectedReportType=='Trainings' && selectedOrgValue.length>0">
        <div>
          <label for="email"><b>Select Trainer &nbsp;: &nbsp;
            </b></label>
        </div>
        <mat-select matInput multiple placeholder="Select" #documentType style="position: absolute; width: 18%;"
          [(ngModel)]="searchByInstructorTrainer" (closed)="trainerSearchText=''"
          (click)="focusSearch('document-type-search4')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="document-type-search4" class="dropdownsearchstyle" [(ngModel)]="trainerSearchText"
            matInput placeholder="search">
          <mat-option
            *ngFor="let item of getTmsInstructorTrainerDataList | multiAssessmentSearchPipe : trainerSearchText"
            [value]="item.valueExp" (onSelectionChange)="onTraininerSelectAllnew($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3"
        *ngIf="selectedReportType=='Trainings' && selectedOption=='Department' && selectedOrgValue.length>0">
        <div> <label for="email" id="departmentNameAlert" style="margin-top: -10px;"><b> Department <span
                class="mandatory-symbol">*</span>&nbsp;: &nbsp;
            </b></label></div>
        <mat-select matInput multiple placeholder="Select" #documentType style="position: absolute; width: 18%;"
          [(ngModel)]="searchByDepartmentCodeMain" (closed)="departmentSearchText2=''"
          (click)="focusSearch('document-type-search3')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="document-type-search3" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText2" matInput placeholder="search">
          <mat-option *ngFor="let item of departmentListDropdown | multiAssessmentSearchPipe : departmentSearchText2"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>


      <div class="col-md-3" *ngIf="selectedReportType=='Documents' && selectedOrgValue.length==1">
        <label for="email" id="manageDMSReportNameAlert">
          <b> Report Name<span class="mandatory-symbol">*</span> &nbsp;: &nbsp; </b>
        </label>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDMSReportTypeMain" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-title-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-title-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search" (ngModelChange)="onNgModelChange($event,'manageDMSReportNameAlert')">

          <mat-option *ngFor="let item of reportTypeForDMSDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onDMSReportTypeSelectnew($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3" *ngIf="selectedReportType=='Documents' && selectedOrgValue.length==1 && showDateRange">
        <div><label for="email"><b>Date Range</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedDateRangeValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search1')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-group-search1" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
          <mat-option *ngFor="let item of dateRangeValueDropdown | assessmentSearch : groupSearchText"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="row" *ngIf="selectedReportType=='Documents' && selectedOrgValue.length==1 && showDateRange">

        <div class="col-md-3">
          <label for="email"><b>From Date</b> : </label>
          <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate">
        </div>
        <div class="col-md-3">
          <label for="email"><b>To Date</b> : </label>
          <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate">
        </div>
        <div class="col-md-3">
          <div><label for="email"><b>Interval</b> : </label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedIntervalValue" (closed)="groupSearchText=''"
            (click)="focusSearch('focus-group-search2')" (keydown.enter)="focusSearch('focus-Logo-search')">
            <input type="search" id="focus-group-search2" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
            <mat-option *ngFor="let item of intervalValueDropdown | assessmentSearch : groupSearchText"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>


      <div class="col-md-3" *ngIf="onSelectedOptionForDMS=='Inventory' && selectedReportType=='Documents'">
        <div><label for="email" id="folder"><b> Folder Path</b> :</label></div>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" [(ngModel)]="dmsGroupFoldersFieldData.folderName"
            [disabled]="visibleDmsGroupFoldersReasonForUpdateField === true" (click)="searchDocumentFunction()">
        </div>
      </div>
      <div class="col-md-3" *ngIf="onSelectedOptionForDMS=='Inventory' && selectedReportType=='Documents'">
        <div><label for="email" id="documentTypes1"><b>Document Type</b></label></div>
        <mat-select matInput multiple placeholder="Select" #documentType [(ngModel)]="selectedDocumentType"
          (closed)="documentTypeSearchText=''" (click)="focusSearch('document-type-search2')">
          <input type="search" id="document-type-search2" class="dropdownsearchstyle"
            [(ngModel)]="documentTypeSearchText" matInput placeholder="search">
          <mat-option *ngFor="let item of documentTypeDropdown | multiAssessmentSearchPipe : documentTypeSearchText"
            [value]="item.valueExp" (onSelectionChange)="ondocumentTypeSelectnew($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-1"
        *ngIf="dmsGroupFoldersFieldData.folderPath=='Repository' && onSelectedOptionForDMS=='Inventory' && selectedReportType=='Documents'">
        <label for=""><b> Physical</b></label>
        <div style="bottom: 235px;">
          <input type="checkbox" style="zoom: 1.2;margin-top: 3px;" [checked]="physicalFolderLevel"
            (change)="showPhysicalFolderLevel($event)">
        </div>
      </div>
      <div class="col-md-2"
        *ngIf="dmsGroupFoldersFieldData.folderPath=='Repository'  && onSelectedOptionForDMS=='Inventory' && selectedReportType=='Documents'">
        <label for=""><b> Distributed</b></label>
        <div style="bottom: 235px;">
          <input type="checkbox" style="zoom: 1.2; margin-top: 3px;" [checked]="distributedFolderLevel"
            (change)="showDstributedFolderLevel($event)">
        </div>
      </div>
      <div class="col-md-3" *ngIf="onSelectedOptionForDMS=='Master Index' && selectedReportType=='Documents'">
        <div><label for="email" id="folderMasterAlert" #folderMasterAlert><b> Folder Path</b> <span
              class="mandatory-symbol">*</span>:</label></div>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" [(ngModel)]="dmsGroupFoldersFieldData.folderName"
            [disabled]="visibleDmsGroupFoldersReasonForUpdateField === true" (click)="searchDocumentFunction()"
            (ngModelChange)="onNgModelChange(dmsGroupFoldersFieldData.folderName,'folderMasterAlert')">
        </div>
      </div>
      <div class="col-md-3" style="margin-top: 25px;"
        *ngIf="onSelectedOptionForDMS=='Master Index' && selectedReportType=='Documents'">
        <div><label for="email" id="documentTypes"><b>Document Type</b></label></div>
        <mat-select matInput multiple placeholder="Select" #documentType [(ngModel)]="selectedDocumentType"
          (closed)="documentTypeSearchText=''" (click)="focusSearch('document-type-search1')"
          (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="document-type-search1" class="dropdownsearchstyle"
            [(ngModel)]="documentTypeSearchText" matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="newdocumentTypeSelection" (change)="toggleAllSelection2('newDocumentType')">
              Select Alll</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of documentTypeDropdown | multiAssessmentSearchPipe : documentTypeSearchText"
            (onSelectionChange)="onDocTypeChanges()" [value]="item.valueExp"> {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-9" *ngIf="onSelectedOptionForDMS=='Master Index' && selectedReportType=='Documents'">
        <div class="row" style="margin-top: 42px;background-color: whitesmoke;">
          <div class="col-md-4">
            <label for=" "><b>Include Amendments</b></label>
            <div style="bottom: 235px;">
              <input type="checkbox" style="zoom: 1.2; margin-top: 3px;" [checked]="includeAmendmentsFlg"
                (change)="showIncludeAmendmentsFlg($event)">
            </div>
          </div>
          <div class="col-md-4">
            <label for=" "><b>Include Associated Documents</b></label>
            <div style="bottom: 235px;">
              <input type="checkbox" style="zoom: 1.2; margin-top: 3px;" [checked]="associatedDocFlg"
                (change)="showAssociatedDocFlg($event)">
            </div>
          </div>
          <div class="col-md-4">
            <label for=" "><b>Include Belongs to Individual Documents</b></label>
            <div style="bottom: 235px;">
              <input type="checkbox" style="zoom: 1.2; margin-top: 3px;" [checked]="individualDocFlg"
                (change)="showIndividualFlg($event)">
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="d-flex gap-3 my-3 ms-2">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="genReport()"
          (keydown.enter)="focusSearch('focus-Logo-search')">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Generate</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="resetFunction()"
          (keydown.enter)="focusSearch('focus-Logo-search')">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reset" />
          <span class="reload_text">Reset</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="tableType!='' && selectedReportType=='Quality' && selectedType=='Activity'" #captureDiv1>
  <div class="row">
    <div class="menu-container">
      <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container">
          <span class="tms-reports_title">Organization</span>
        </div>
        <div class="col-sm-6 action-buttons-container" style="margin-left: 52%;margin-top: -27px;">
          <mat-slide-toggle color="primary" (ngModelChange)="showDeleteAndObsolute()"
            matTooltip="Show Deleted\Obsoleted" [(ngModel)]="showAdditionalMenus"></mat-slide-toggle>
          <div (click)="exportExcelFromFrontendcall()" (keydown.enter)="focusSearch('focus-Logo-search')"
            matTooltip="Download Count Excel">
            <i class="fas fa-file-excel"></i>
          </div>
          <div (click)="captureElement1()" (keydown.enter)="focusSearch('focus-Logo-search')"
            matTooltip="Download Screenshot"><i class="fas fa-download"></i></div>
          &nbsp;&nbsp;
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="row" *ngIf="tableType=='multi'">
      <div class="col-md-6" *ngIf="selectedModule!=null">
        <table border="1">
          <thead>
            <tr>
              <th rowspan="2" class="org-name-column1">Organization Name</th>
              <th *ngFor="let module of moduless" style="cursor: pointer;" [attr.colspan]="showAdditionalMenus ? 5 : 4"
                class="center-text" (click)="getGroupDetails(module)"
                (keydown.enter)="focusSearch('focus-Logo-search')">{{
                module }}</th>
            </tr>
            <tr>
              <ng-container *ngFor="let module of moduless">
                <th class="center-text">Total</th>
                <th class="center-text"><img src="../../../assets/img/ban.png" width="12px" height="12px"
                    matTooltip="Closed" alt="Closed"></th>
                <th class="center-text"><img src="../../../assets/img/enter.png" width="12px" height="12px"
                    matTooltip="Open" alt="Open"></th>
                <th class="center-text"><i class="fa fa-clock-o" matTooltip="Overdue"></i></th>
                <th class="center-text" *ngIf="showAdditionalMenus"> <i class="fa fa-trash"
                    matTooltip="Deleted/Obsoleted"></i> </th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let org of uniqueOrgNames">
              <td class="org-name-column">{{ org }}</td>
              <ng-container *ngFor="let module of moduless">
                <td class="center-text" style="cursor: pointer;" (click)="getGroupTableDetails(org, module,'All','o')"
                  (keydown.enter)="focusSearch('focus-Logo-search')">
                  {{ getTotalCount(org, module) }}</td>
                <td class="center-text" style="cursor: pointer;"
                  (click)="getGroupTableDetails(org, module,'Closed','o')"
                  (keydown.enter)="focusSearch('focus-Logo-search')"><span *ngIf="!showPercentage">{{
                    getCount(org, module, 'Closed') }}</span><span
                    *ngIf="showPercentage && getTotalCount(org, module)!=0">{{getCount(org, module,
                    'Closed')/getTotalCount(org, module)*100+0 | number:'1.0-0' }}%</span></td>
                <td class="center-text" style="cursor: pointer;" (click)="getGroupTableDetails(org, module,'Open','o')"
                  (keydown.enter)="focusSearch('focus-Logo-search')">
                  <span *ngIf="!showPercentage">{{ getCount(org, module, 'Open') }}</span><span
                    *ngIf="showPercentage && getTotalCount(org, module)!=0">{{getCount(org, module,
                    'Open')/getTotalCount(org, module)*100+0 | number:'1.0-0' }}%</span>
                </td>
                <td class="center-text" style="cursor: pointer;"
                  (click)="getGroupTableDetails(org, module,'Overdue','o')"
                  (keydown.enter)="focusSearch('focus-Logo-search')"><span *ngIf="!showPercentage">{{
                    getOverdueCount(org, module) }}</span><span
                    *ngIf="showPercentage && getTotalCount(org, module)!=0">{{ getOverdueCount(org,
                    module)/getTotalCount(org, module)*100+0 | number:'1.0-0' }}%</span></td>
                <td class="center-text" style="cursor: pointer;"
                  (click)="getGroupTableDetails(org, module,'Deleted/Obsoleted','o')"
                  (keydown.enter)="focusSearch('focus-Logo-search')" *ngIf="showAdditionalMenus"><span
                    *ngIf="!showPercentage">{{
                    getCount(org, module, 'Deleted/Obsoleted') }}</span><span
                    *ngIf="showPercentage && getTotalCount(org, module)!=0">{{getCount(org, module,
                    'Deleted/Obsoleted')/getTotalCount(org, module)*100+0 | number:'1.0-0' }}%</span></td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-6" *ngIf="selectedModule!=null">
        <canvasjs-chart [options]="chartOptionsForOrgTotal" [styles]="{width: '100%', height:'250px'}"></canvasjs-chart>
      </div>

      <div class="col-md-9" *ngIf="selectedModule==null">
        <table border="1">
          <thead>
            <tr>
              <th rowspan="2" class="org-name-column1">Organization Name</th>
              <th *ngFor="let module of moduless" [attr.colspan]="showAdditionalMenus ? 5 : 4" style="cursor: pointer;"
                class="center-text" (click)="getGroupDetails(module)"
                (keydown.enter)="focusSearch('focus-Logo-search')">{{
                module }}</th>
            </tr>
            <tr>
              <ng-container *ngFor="let module of moduless">
                <th class="center-text">Total</th>
                <th class="center-text"><img src="../../../assets/img/ban.png" width="12px" height="12px"
                    matTooltip="Closed" alt="Closed"></th>
                <th class="center-text"><img src="../../../assets/img/enter.png" width="12px" height="12px"
                    matTooltip="Open" alt="Open"></th>
                <th class="center-text"><i class="fa fa-clock-o" matTooltip="Overdue"></i></th>
                <th class="center-text" *ngIf="showAdditionalMenus"> <i class="fa fa-trash"
                    matTooltip="Deleted/Obsoleted"></i> </th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let org of uniqueOrgNames">
              <td class="org-name-column" style="cursor: pointer;">{{ org }}</td>
              <ng-container *ngFor="let module of moduless">
                <td class="center-text" style="cursor: pointer;" (click)="getGroupTableDetails(org, module,'All','o')"
                  (keydown.enter)="focusSearch('focus-Logo-search')">
                  {{ getTotalCount(org, module) }}</td>
                <td class="center-text" style="cursor: pointer;"
                  (click)="getGroupTableDetails(org, module,'Closed','o')"
                  (keydown.enter)="focusSearch('focus-Logo-search')"><span *ngIf="!showPercentage">{{
                    getCount(org, module, 'Closed') }}</span><span
                    *ngIf="showPercentage && getTotalCount(org, module)!=0">{{getCount(org, module,
                    'Closed')/getTotalCount(org, module)*100+0 | number:'1.0-0' }}%</span></td>
                <td class="center-text" style="cursor: pointer;" (click)="getGroupTableDetails(org, module,'Open','o')"
                  (keydown.enter)="focusSearch('focus-Logo-search')">
                  <span *ngIf="!showPercentage">{{ getCount(org, module, 'Open') }}</span><span
                    *ngIf="showPercentage && getTotalCount(org, module)!=0">{{getCount(org, module,
                    'Open')/getTotalCount(org, module)*100+0 | number:'1.0-0' }}%</span>
                </td>
                <td class="center-text" style="cursor: pointer;"
                  (click)="getGroupTableDetails(org, module,'Overdue','o')"
                  (keydown.enter)="focusSearch('focus-Logo-search')"><span *ngIf="!showPercentage">{{
                    getOverdueCount(org, module) }}</span><span
                    *ngIf="showPercentage && getTotalCount(org, module)!=0">{{ getOverdueCount(org,
                    module)/getTotalCount(org, module)*100+0 | number:'1.0-0' }}%</span></td>
                <td class="center-text" style="cursor: pointer;"
                  (click)="getGroupTableDetails(org, module,'Deleted/Obsoleted','o')"
                  (keydown.enter)="focusSearch('focus-Logo-search')" *ngIf="showAdditionalMenus"><span
                    *ngIf="!showPercentage">{{
                    getCount(org, module, 'Deleted/Obsoleted') }}</span><span
                    *ngIf="showPercentage && getTotalCount(org, module)!=0">{{getCount(org, module,
                    'Deleted/Obsoleted')/getTotalCount(org, module)*100+0 | number:'1.0-0' }}%</span></td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-3" *ngIf="selectedModule==null">
        <canvasjs-chart [options]="chartOptionsForOrgTotal" [styles]="{width: '100%', height:'250px'}"></canvasjs-chart>
      </div>
    </div>
    <div class="row" *ngIf="tableType=='single'">
      <div class="col-md-4">
        <table border="1" class="custom-table">
          <thead>
            <tr>
              <th class="center-text module-column">Modules</th>
              <th class="center-text">Total</th>
              <th class="center-text"><img src="../../../assets/img/ban.png" width="12px" height="12px"
                  matTooltip="Closed" alt="Closed"></th>
              <th class="center-text"><img src="../../../assets/img/enter.png" width="12px" height="12px"
                  matTooltip="Open" alt="Open"></th>
              <th class="center-text"><i class="fa fa-clock-o" matTooltip="Overdue"></i></th>
              <th class="center-text" *ngIf="showAdditionalMenus"> <i class="fa fa-trash"
                  matTooltip="Deleted/Obsoleted"></i> </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let module of moduless">
              <td class="org-name-column" style="cursor: pointer;" (click)="getGroupDetails(module)"
                (keydown.enter)="focusSearch('focus-Logo-search')">{{ module }}</td>
              <td class="center-text" style="cursor: pointer;" (click)="getGroupTableDetails('', module,'All','o')"
                (keydown.enter)="focusSearch('focus-Logo-search')">{{
                getTotalCountBymodule(module) }}</td>
              <td class="center-text" style="cursor: pointer;" (click)="getGroupTableDetails('', module,'Closed','o')"
                (keydown.enter)="focusSearch('focus-Logo-search')">
                <span *ngIf="!showPercentage">{{ getCountBymodule(module, 'Closed') }}</span><span
                  *ngIf="showPercentage &&  getTotalCountBymodule(module)!=0">{{getCountBymodule(module, 'Closed')/
                  getTotalCountBymodule(module)*100+0 | number:'1.0-0' }}%</span>
              </td>
              <td class="center-text" style="cursor: pointer;" (click)="getGroupTableDetails('', module,'Open','o')"
                (keydown.enter)="focusSearch('focus-Logo-search')">
                <span *ngIf="!showPercentage">{{ getCountBymodule(module, 'Open') }}</span><span
                  *ngIf="showPercentage &&  getTotalCountBymodule(module)!=0">{{getCountBymodule(module, 'Open')/
                  getTotalCountBymodule(module)*100+0 | number:'1.0-0' }}%</span>
              </td>
              <td class="center-text" style="cursor: pointer;" (click)="getGroupTableDetails('', module,'Overdue','o')"
                (keydown.enter)="focusSearch('focus-Logo-search')">
                <span *ngIf="!showPercentage">{{ getOverdueCountBymodule(module) }}</span><span
                  *ngIf="showPercentage &&  getTotalCountBymodule(module)!=0">{{getOverdueCountBymodule(module)/
                  getTotalCountBymodule(module)*100+0 | number:'1.0-0' }}%</span>
              </td>
              <td class="center-text" style="cursor: pointer;"
                (click)="getGroupTableDetails('', module,'Deleted/Obsoleted','o')"
                (keydown.enter)="focusSearch('focus-Logo-search')" *ngIf="showAdditionalMenus"><span
                  *ngIf="!showPercentage">{{
                  getCountBymodule(module, 'Deleted/Obsoleted') }}</span><span
                  *ngIf="showPercentage &&  getTotalCountBymodule(module)!=0">{{getCountBymodule(module,
                  'Deleted/Obsoleted')/ getTotalCountBymodule(module)*100+0 | number:'1.0-0' }}%</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-8">
        <canvasjs-chart [options]="chartOptionsForModulesTotal"
          [styles]="{width: '100%', height:'280px'}"></canvasjs-chart>
      </div>
    </div>
  </div>
  <br />
</div>
<div *ngIf="selectedReportType=='Quality'">
  <div class="row" #captureDiv>
    <div class="row" [hidden]="!showGroupGrid">
      <div class="menu-container">
        <div class="row menu-row-container">
          <div class="col-sm-6 gridName-container">
            <span class="tms-reports_title">Groups</span>
          </div>
          <div class="col-sm-6 action-buttons-container" style="margin-left: 52%;margin-top: -27px;">
            <div (click)="exportGroupExcelFromFrontendcall()" (keydown.enter)="focusSearch('focus-Logo-search')"
              matTooltip="Download Count Excel">
              <i class="fas fa-file-excel"></i>
            </div>
            <div (click)="captureElement()" (keydown.enter)="focusSearch('focus-Logo-search')"
              matTooltip="Download Screenshot"><i class="fas fa-download"></i></div>
            &nbsp;&nbsp;
          </div>
        </div>
      </div>
    </div>
    <div [hidden]="!showGroupGrid">
      <div class="row">
        <div class="col-md-4">
          <div style="display: flex; align-items: stretch; width: fit-content; border-collapse: collapse;" class="mt-2">
            <table border="1" style="border-collapse: collapse; max-height: 280px; overflow-y: scroll;">
              <thead>
                <tr>
                  <th rowspan="2" class="org-name-column1">Organization Name</th>
                  <th rowspan="2" class="org-name-column1">Group Name</th>

                  <th class="center-text">Total</th>
                  <th class="center-text">
                    <img src="../../../assets/img/ban.png" width="12px" height="12px" matTooltip="Closed" alt="Closed">
                  </th>
                  <th class="center-text">
                    <img src="../../../assets/img/enter.png" width="12px" height="12px" matTooltip="Open" alt="Open">
                  </th>
                  <th class="center-text"><i class="fa fa-clock-o" matTooltip="Overdue"></i></th>


                  <ng-container *ngIf="showAdditionalMenus">

                    <th class="center-text"><i class="fa fa-trash" matTooltip="Deleted/Obsoleted"></i></th>
                  </ng-container>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let groupName of uniqueOrgNamesForGroup">

                  <td class="org-name-column" style="cursor: pointer;">
                    {{ getOrgNameForGroup(groupName,'') }}
                  </td>


                  <td class="org-name-column" style="cursor: pointer;">
                    {{ groupName }}
                  </td>

                  <ng-container *ngFor="let module of modulesForGroup">

                    <td class="center-text" style="cursor: pointer;"
                      (click)="getGroupTableDetails(groupName, module,'All','g')"
                      (keydown.enter)="getGroupTableDetails(groupName, module,'All','g')">
                      {{ getTotalCountForGroup(groupName, module) }}
                    </td>
                    <td class="center-text" style="cursor: pointer;"
                      (click)="getGroupTableDetails(groupName, module,'Closed','g')"
                      (keydown.enter)="getGroupTableDetails(groupName, module,'Closed','g')">
                      <span *ngIf="!showPercentage">{{ getCountForGroup(groupName, module, 'Closed') }}</span>
                      <span *ngIf="showPercentage && getTotalCountForGroup(groupName, module)!=0">
                        {{ (getCountForGroup(groupName,module,'Closed')/getTotalCountForGroup(groupName,module)*100) |
                        number:'1.0-0' }}%
                      </span>
                    </td>

                    <td class="center-text" style="cursor: pointer;"
                      (click)="getGroupTableDetails(groupName, module,'Open','g')"
                      (keydown.enter)="getGroupTableDetails(groupName, module,'Open','g')">
                      <span *ngIf="!showPercentage">{{ getCountForGroup(groupName, module, 'Open') }}</span>
                      <span *ngIf="showPercentage && getTotalCountForGroup(groupName, module)!=0">
                        {{ (getCountForGroup(groupName,module,'Open')/getTotalCountForGroup(groupName,module)*100) |
                        number:'1.0-0' }}%
                      </span>
                    </td>

                    <td class="center-text" style="cursor: pointer;"
                      (click)="getGroupTableDetails(groupName, module,'Overdue','g')"
                      (keydown.enter)="getGroupTableDetails(groupName, module,'Overdue','g')">
                      <span *ngIf="!showPercentage">{{ getOverdueCountForGroup(groupName, module) }}</span>
                      <span *ngIf="showPercentage && getTotalCountForGroup(groupName, module)!=0">
                        {{ (getOverdueCountForGroup(groupName,module)/getTotalCountForGroup(groupName,module)*100) |
                        number:'1.0-0' }}%
                      </span>
                    </td>


                    <ng-container *ngIf="showAdditionalMenus">

                      <td class="center-text" style="cursor: pointer;"
                        (click)="getGroupTableDetails(groupName, module,'Deleted/Obsoleted','g')"
                        (keydown.enter)="getGroupTableDetails(groupName, module,'Deleted/Obsoleted','g')">
                        <span *ngIf="!showPercentage">{{ getCountForGroup(groupName, module, 'Deleted/Obsoleted')
                          }}</span>
                        <span *ngIf="showPercentage && getTotalCountForGroup(groupName, module)!=0">
                          {{
                          (getCountForGroup(groupName,module,'Deleted/Obsoleted')/getTotalCountForGroup(groupName,module)*100)
                          | number:'1.0-0' }}%
                        </span>
                      </td>
                    </ng-container>
                  </ng-container>
                </tr>
              </tbody>
            </table>
            <div style="display: flex; align-items: center; border-top: 1px solid black;
                      border-bottom: 1px solid black; border-right: 1px solid black; padding: 0 8px;cursor: pointer;"
              (click)="toggleMenus()" (keydown.enter)="toggleMenus()">
              <i *ngIf="!showAdditionalMenus" class="fa fa-chevron-right toggle-arrow" title="Expand"></i>
              <i *ngIf="showAdditionalMenus" class="fa fa-chevron-left toggle-arrow" title="Collapse"></i>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div id="chartContainer" style="height: 270px; width: 100%;"></div>
        </div>
      </div>
    </div>
    <br />
  </div>

  <div class="menu-container" *ngIf="tableType!='' && selectedReportType=='Quality' && selectedType=='Activity'">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="tms-reports_title">Status Chart</span>
      </div>
    </div>
  </div>
  <div class="row"
    *ngIf="tableType!='' && selectedReportType=='Quality' && selectedType=='Activity' && selectedModule==null">
    <div class="col-md-4" *ngIf="dashboardCountListCR.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusCR" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('CR')"></canvasjs-chart>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListCAPA.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusCAPA" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('CAPA')"></canvasjs-chart>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListDV.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusDV" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('DV')"></canvasjs-chart>
    </div>
  </div>

  <br />
  <div class="row"
    *ngIf="tableType!='' && selectedReportType=='Quality' && selectedType=='Activity' && selectedModule==null">
    <div class="col-md-4" *ngIf="dashboardCountListIN.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusIN" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('IN')"></canvasjs-chart>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListQI.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusQI" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('QI')"></canvasjs-chart>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListAU.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusAU" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('AU')"></canvasjs-chart>
    </div>
  </div>
  <br />
  <div class="row"
    *ngIf="tableType!='' && selectedReportType=='Quality' && selectedType=='Activity' && selectedModule==null">
    <div class="col-md-4" *ngIf="dashboardCountListCC.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusCC" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('CC')"></canvasjs-chart>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListOOS.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusOOS" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('OOS')"></canvasjs-chart>
    </div>
  </div>
  <div class="row"
    *ngIf="tableType!='' && selectedReportType=='Quality' && selectedType=='Activity' && selectedModule!=null">
    <div class="col-md-12" *ngIf="dashboardCountListCR.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusCR" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('CR')"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListCAPA.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusCAPA" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('CAPA')"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListDV.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusDV" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('DV')"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListIN.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusIN" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('IN')"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListQI.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusQI" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('QI')"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListAU.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusAU" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('AU')"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListCC.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusCC" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('CC')"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListOOS.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusOOS" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('OOS')"></canvasjs-chart>
    </div>
  </div>
  <br />
  <div class="menu-container" *ngIf="selectedReportType=='Quality' && selectedType=='Activity'">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="tms-reports_title">Due Chart</span>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="selectedReportType=='Quality' && selectedType=='Activity'">
    <div class="col-md-4" *ngIf="dashboardCountListCRDue.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusCRDue" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('CR')"></canvasjs-chart>
    </div><br />
    <div class="col-md-4" *ngIf="dashboardCountListCAPADue.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusCAPADue" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('CAPA')"></canvasjs-chart>
    </div><br />
    <div class="col-md-4" *ngIf="dashboardCountListDVDue.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusDVDue" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('DV')"></canvasjs-chart>
    </div><br />
    <div class="col-md-4" *ngIf="dashboardCountListINDue.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusINDue" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('IN')"></canvasjs-chart>
    </div><br />
    <div class="col-md-4" *ngIf="dashboardCountListQIDue.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusQIDue" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('QI')"></canvasjs-chart>
    </div><br />
    <div class="col-md-4" *ngIf="dashboardCountListAUDue.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusAUDue" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('AU')"></canvasjs-chart>
    </div><br />
    <div class="col-md-4" *ngIf="dashboardCountListCCDue.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusCCDue" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('CC')"></canvasjs-chart>
    </div><br />
    <div class="col-md-4" *ngIf="dashboardCountListOOSDue.length>0">
      <canvasjs-chart [options]="chartOptionsForStatusOOSDue" [styles]="{width: '100%', height:'200px'}"
        (dblclick)="chartDoubleClicks('OOS')"></canvasjs-chart>
    </div>
  </div>
  <br />
  <div class="menu-container" *ngIf="selectedReportType=='Quality' && selectedType=='Action'">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="tms-reports_title">Action Chart</span>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="selectedReportType=='Quality' && selectedType=='Action' && selectedModule==null">
    <div class="col-md-4" *ngIf="dashboardCountListCRAction.length>0">
      <div id="chartOptionsForStatusCRActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionCR')"></div>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListCAPAAction.length>0">
      <div id="chartOptionsForStatusCAPAActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionCAPA')"></div>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListDVAction.length>0">
      <div id="chartOptionsForStatusDVActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionDV')"></div>
    </div>
  </div>
  <br />
  <div class="row" *ngIf="selectedReportType=='Quality' && selectedType=='Action' && selectedModule==null">
    <div class="col-md-4" *ngIf="dashboardCountListINAction.length>0">
      <div id="chartOptionsForStatusINActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionIN')"></div>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListQIAction.length>0">
      <div id="chartOptionsForStatusQIActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionQI')"></div>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListCCAction.length>0">
      <div id="chartOptionsForStatusCCActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionCC')"></div>
    </div>
  </div>
  <br />
  <div class="row" *ngIf="selectedReportType=='Quality' && selectedType=='Action' && selectedModule==null">
    <div class="col-md-4" *ngIf="dashboardCountListOOSAction.length>0">
      <div id="chartOptionsForStatusOOSActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionOOS')"></div>
    </div>
  </div>
  <br />
  <div class="row" *ngIf="selectedReportType=='Quality' && selectedType=='Action' && selectedModule!=null">
    <div class="col-md-12" *ngIf="dashboardCountListCRAction.length>0">
      <div id="chartOptionsForStatusCRActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionCR')"></div>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListCAPAAction.length>0">
      <div id="chartOptionsForStatusCAPAActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionCAPA')"></div>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListDVAction.length>0">
      <div id="chartOptionsForStatusDVActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionDV')"></div>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListINAction.length>0">
      <div id="chartOptionsForStatusINActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionIN')"></div>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListQIAction.length>0">
      <div id="chartOptionsForStatusQIActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionQI')"></div>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListCCAction.length>0">
      <div id="chartOptionsForStatusCCActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionCC')"></div>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListOOSAction.length>0">
      <div id="chartOptionsForStatusOOSActionid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('ActionOOS')"></div>
    </div>
  </div>
  <br />
  <div class="row" *ngIf="selectedReportType=='Quality' && selectedType=='Action'">
    <div class="col-md-4" *ngIf="dashboardCountListCRActionDue.length>0">
      <div id="chartOptionsForStatusCRActionDueid" style="height: 250px; width: 100%;"></div>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListCAPAActionDue.length>0">
      <div id="chartOptionsForStatusCAPAActionDueid" style="height: 250px; width: 100%;"></div>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListDVActionDue.length>0">
      <div id="chartOptionsForStatusDVActionDueid" style="height: 250px; width: 100%;"></div>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListINActionDue.length>0">
      <div id="chartOptionsForStatusINActionDueid" style="height: 250px; width: 100%;"></div>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListQIActionDue.length>0">
      <div id="chartOptionsForStatusQIActionDueid" style="height: 250px; width: 100%;"></div>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListCCActionDue.length>0">
      <div id="chartOptionsForStatusCCActionDueid" style="height: 250px; width: 100%;"></div>
    </div>
    <div class="col-md-4" *ngIf="dashboardCountListOOSActionDue.length>0">
      <div id="chartOptionsForStatusOOSActionDueid" style="height: 250px; width: 100%;"></div>
    </div>
  </div>
  <br />

  <div class="row" *ngIf="selectedReportType=='Quality' && selectedType=='Finding'">
    <div class="menu-container">
      <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container">
          <span class="tms-reports_title">Finding Chart</span>
        </div>
      </div>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListAUFinding.length>0">
      <div id="chartOptionsForStatusAUFindingid" style="height: 250px; width: 100%;"
        (dblclick)="chartDoubleClicks('Finding')"></div>
    </div>

  </div>

  <br />
  <div class="row" *ngIf="selectedReportType=='Quality' && selectedType=='Finding'">
    <div class="menu-container">
      <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container">
          <span class="tms-reports_title">Finding Due Chart</span>
        </div>
      </div>
    </div>
    <div class="col-md-12" *ngIf="dashboardCountListAUFindingDue.length>0">
      <div id="chartOptionsForStatusAUFindingDueid" style="height: 250px; width: 100%;"></div>
    </div>

  </div>

  <div class="row" #captureDivTOD style="width: 100%; overflow: visible;"
    *ngIf="specificIntervalVal && tableType!='' && selectedReportType=='Quality' && selectedType=='Activity'">
    <div class="row">
      <div class="menu-container">
        <div class="row menu-row-container">
          <div class="col-sm-6 gridName-container">
            <span class="tms-reports_title">Total Vs Overdue</span>
          </div>
          <div class="col-sm-6 action-buttons-container" style="margin-left: 52%;margin-top: -27px;">
            <div (click)="captureElementTOD()" (keydown.enter)="focusSearch('focus-Logo-search')"
              matTooltip="Download Screenshot"><i class="fas fa-download"></i></div>
            &nbsp;&nbsp;
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div id="chartContainer2" style="height: 250px; width: 100%;"></div>
      </div>
      <div class="col-md-6">
        <div id="chartContainer3" style="height: 250px; width: 100%;"></div>
      </div>
    </div>
  </div>
  <br />
</div>
<div *ngIf="selectedReportType=='Trainings'">
  <div class="row" style="margin-top:50px;" *ngIf="totalVal!=0" #captureDiv11>
    <div class="menu-container">
      <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container">
          <span class="tms-reports_title" Style="margin-left:-38px;">{{selectedOption}}</span>
        </div>
        <div class="col-sm-6 action-buttons-container" style="margin-left: 52%;margin-top: -27px;">
          <div *ngIf="!notCompleted"><label for="email">Expand Details</label>
          </div>
          <div *ngIf="notCompleted"><label for="email">Collapse Details</label>
          </div>
          &nbsp;&nbsp;
          <mat-slide-toggle color="primary" (ngModelChange)="showNotCompleted()"
            [(ngModel)]="notCompleted"></mat-slide-toggle>
          &nbsp;&nbsp;
          <div (click)="captureElementTMS()" matTooltip="Download Screenshot"><i class="fas fa-download"></i>
          </div>
          &nbsp;&nbsp;
          <div *ngIf="selectedOption == 'Organization'">
            <i class="fa fa-file-excel-o" style="font-size:18px;color:bule" (click)="openReportPopupOrg()"
              (keydown.enter)="focusSearch('focus-Logo-search')"></i>
          </div>
          <div *ngIf="selectedOption != 'Organization'">
            <i class="fa fa-file-excel-o" style="font-size:18px;color:bule" (click)="openReportPopupOrg()"
              (keydown.enter)="focusSearch('focus-Logo-search')"></i>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-md-9" *ngIf="notCompleted && selectedOption != 'Organization'">
        <div class="panel">
          <div class="detail-menu-container">
            <div class="mini-chart-container" (click)="overAllGetDetails('All')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu">
                    <img src="../../../assets/img/cr_module/total_requests.svg" width="16px" height="16px"
                      alt="Total" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{totalVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Total
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('PENDING')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu pending_request">
                    <img src="../../../assets/img/tms/yet.svg" width="16px" height="16px" alt="Pending" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{pendingVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Pending
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('COMPLETED')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu active_request">
                    <img src="../../../assets/img/tms/pass.svg" width="16px" height="16px" alt="Completed" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{completedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Completed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('FAILED')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu overdue_request">
                    <img src="../../../assets/img/tms/fail.svg" width="16px" height="16px" alt="Failed" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{failedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Failed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('SCHEDULED')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu other_request">
                    <img src="../../../assets/img/tms/sch.svg" width="16px" height="16px" alt="Scheduled" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{scheduledVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Scheduled
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('INPROGRESS')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu inpro_request">
                    <img src="../../../assets/img/processing-time.png" width="16px" height="16px" alt="Inprogress" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{inprogressVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Inprogress
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('OVERDUE')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu over_request">
                    <img src="../../../assets/img/time.png" width="16px" height="16px" alt="Overdue" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{overdueVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Overdue
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" (click)="overAllGetDetails('LOCKED')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu lock_request">
                    <img src="../../../assets/img/padlock (1).png" width="16px" height="16px" alt="Locked" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{lockedVal}}
                  </span>s
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Locked
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu my_total_request">
                    <img src="../../../assets/img/tms/per.svg" width="16px" height="16px" alt="%" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{passPerVal}} %
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Pass
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-header">
            <div class="table-cell-th name"
              *ngIf="selectedOption=='Users' || selectedOption=='Team Member Trainings' || selectedOption=='Organization'">
              User Name</div>
            <div class="table-cell-th" *ngIf="selectedOption=='Department'">Department</div>
            <div class="table-cell-th name" *ngIf="selectedOption=='Training Groups'">User Name</div>
            <div class="table-cell-th" style="min-width: 200px;"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'">
              Training Name
            </div>
            <div class="table-cell-th" *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'">
              Version</div>
            <div class="table-cell-th">Total</div>
            <div class="table-cell-th">Pending</div>
            <div class="table-cell-th">Completed</div>
            <div class="table-cell-th">Failed</div>
            <div class="table-cell-th">Scheduled</div>
            <div class="table-cell-th">Inprogress</div>
            <div class="table-cell-th">Overdue</div>
            <div class="table-cell-th">Locked</div>
            <div class="table-cell-th">Failed Attempts</div>
            <div class="table-cell-th">Pass %</div>
          </div>
          <div class="table-row" *ngFor="let listOfUsersData of pagedItemsMain; let idx = index;">
            <div class="table-cell name clickable nameAlign"
              *ngIf="selectedOption=='Users' || selectedOption=='Team Member Trainings' || selectedOption=='Organization'"
              (click)="getDetails(idx,'All')" (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.usrFullname}}
            </div>
            <div class="table-cell name clickable nameAlign" *ngIf="selectedOption=='Training Groups'"
              (click)="getDetails(idx,'All')" (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.userName}}
            </div>
            <div class="table-cell name clickable nameAlign" *ngIf="selectedOption=='Department'"
              (click)="getDetails(idx,'All')" (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.departmentCode}}
            </div>
            <div class="table-cell name clickable nameAlign" style="min-width: 200px;"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'"
              (click)="getDetails(idx,'All')" (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.trainingName}}
            </div>
            <div class="table-cell name clickable valueAlign"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'">
              {{listOfUsersData.version}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'All')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'PENDING')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.pending}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'COMPLETED')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.completed}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'FAILED')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.failed}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'SCHEDULED')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.scheduled}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'INPROGRESS')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.inprogress}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'OVERDUE')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.overdue}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'LOCKED')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.locked}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell valueAlign">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>
        <div *ngIf="collectionSize>10">
          <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <div class="col-2 col-md-6 d-flex justify-content-end align-items-center">
            </div>
            <nav class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
              1-{{ perPage }} of {{ collectionSize | number }}
              <ngb-pagination class="leftpadding" (pageChange)="setPageMain(pager.currentPage,$event)"
                [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                  {{perPage}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCallMain(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCallMain(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCallMain(50)">50</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="col-md-9" *ngIf="!notCompleted && selectedOption != 'Organization'">
        <div class="panel">
          <div class="detail-menu-container">
            <div class="mini-chart-container" (click)="overAllGetDetails('All')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu">
                    <img src="../../../assets/img/cr_module/total_requests.svg" width="16px" height="16px"
                      alt="Total" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{totalVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Total
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" (click)="overAllGetDetails('YET_TO_BE_ATTEMPTED')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu pending_request">
                    <img src="../../../assets/img/tms/yet.svg" width="16px" height="16px" alt="Yet To Be Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{yetToBeAttemptedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Yet To Be
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" (click)="overAllGetDetails('ATTEMPTED')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu closed_request">
                    <img src="../../../assets/img/tms/att.svg" width="16px" height="16px" alt="Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{attemptedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Attempted
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" (click)="overAllGetDetails('COMPLETED_AT_ATTEMPTED_CHART')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu active_request">
                    <img src="../../../assets/img/tms/pass.svg" width="16px" height="16px"
                      alt="Completed At Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{completedAtAttemptedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Completed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" (click)="overAllGetDetails('FAILED_AT_ATTEMPTED_CHART')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu overdue_request">
                    <img src="../../../assets/img/tms/fail.svg" width="16px" height="16px" alt="Failed At Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{failedAtAttemptedChartVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Failed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" (click)="overAllGetDetails('SCHEDULED_AT_ATTEMPTED_CHART')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu other_request">
                    <img src="../../../assets/img/tms/sch.svg" width="16px" height="16px"
                      alt="Scheduled At Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{scheduledAtAttemptedChartVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Scheduled
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu my_total_request">
                    <img src="../../../assets/img/tms/per.svg" width="16px" height="16px" alt="%" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{passPerValForAll}} %
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Pass
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-header">
            <div class="table-cell-th name"
              *ngIf="selectedOption=='Users' || selectedOption=='Team Member Trainings' || selectedOption=='Organization'">
              User Name</div>
            <div class="table-cell-th name" *ngIf="selectedOption=='Department'">Department</div>
            <div class="table-cell-th name" *ngIf="selectedOption=='Training Groups'">User Name</div>
            <div class="table-cell-th name" style="min-width: 200px;"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'">Training Name
            </div>
            <div class="table-cell-th name"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'">Version</div>
            <div class="table-cell-th">Total</div>
            <div class="table-cell-th">Yet To Be Attempted</div>
            <div class="table-cell-th">Attempted</div>
            <div class="table-cell-th">Completed</div>
            <div class="table-cell-th">Failed</div>
            <div class="table-cell-th">Scheduled</div>
            <div class="table-cell-th">Failed Attempts</div>
            <div class="table-cell-th">Pass %</div>
          </div>
          <div class="table-row" *ngFor="let listOfUsersData of pagedItemsMain; let idx = index;">
            <div class="table-cell name clickable nameAlign"
              *ngIf="selectedOption=='Users' || selectedOption=='Team Member Trainings' || selectedOption=='Organization'"
              (click)="getDetails(idx,'All')" (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.usrFullname}}
            </div>
            <div class="table-cell name clickable nameAlign" *ngIf="selectedOption=='Training Groups'"
              (click)="getDetails(idx,'All')" (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.userName}}
            </div>
            <div class="table-cell name clickable nameAlign" *ngIf="selectedOption=='Department'"
              (click)="getDetails(idx,'All')" (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.departmentCode}}
            </div>
            <div class="table-cell name clickable nameAlign" style="min-width: 200px;"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'"
              (click)="getDetails(idx,'All')" (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.trainingName}}
            </div>
            <div class="table-cell name clickable valueAlign"
              *ngIf="selectedOption=='Trainings' || selectedOption=='Instructor Trainings'">
              {{listOfUsersData.version}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'All')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'YET_TO_BE_ATTEMPTED')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.yetToBeAttempted}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'ATTEMPTED')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.attempted}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'COMPLETED_AT_ATTEMPTED_CHART')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.completedAtAttemptedChart}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'FAILED_AT_ATTEMPTED_CHART')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.failedAtAttemptedChart}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetails(idx,'SCHEDULED_AT_ATTEMPTED_CHART')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.scheduledAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell valueAlign">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>
        <div *ngIf="collectionSize>10">
          <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <div class="col-2 col-md-6 d-flex justify-content-end align-items-center">
            </div>
            <nav class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
              1-{{ perPage }} of {{ collectionSize | number }}
              <ngb-pagination class="leftpadding" (pageChange)="setPageMain(pager.currentPage,$event)"
                [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                  {{perPage}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCallMain(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCallMain(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCallMain(50)">50</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="col-md-9" *ngIf="notCompleted && selectedOption == 'Organization'">
        <div class="panel">
          <div class="detail-menu-container">
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu">
                    <img src="../../../assets/img/cr_module/total_requests.svg" width="16px" height="16px"
                      alt="Total" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{totalVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Total
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu pending_request">
                    <img src="../../../assets/img/tms/yet.svg" width="16px" height="16px" alt="Pending" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{pendingVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Pending
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu active_request">
                    <img src="../../../assets/img/tms/pass.svg" width="16px" height="16px" alt="Completed" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{completedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Completed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu overdue_request">
                    <img src="../../../assets/img/tms/fail.svg" width="16px" height="16px" alt="Failed" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{failedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Failed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu other_request">
                    <img src="../../../assets/img/tms/sch.svg" width="16px" height="16px" alt="Scheduled" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{scheduledVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Scheduled
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu inpro_request">
                    <img src="../../../assets/img/processing-time.png" width="16px" height="16px" alt="Inprogress" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{inprogressVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Inprogress
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu over_request">
                    <img src="../../../assets/img/time.png" width="16px" height="16px" alt="Overdue" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{overdueVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Overdue
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu lock_request">
                    <img src="../../../assets/img/padlock (1).png" width="16px" height="16px" alt="Locked" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{lockedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Locked
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container1" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu my_total_request">
                    <img src="../../../assets/img/tms/per.svg" width="16px" height="16px" alt="%" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{passPerVal}} %
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Pass
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-header">
            <div class="table-cell-th name">Organization Name</div>
            <div class="table-cell-th">No. Of Users</div>
            <div class="table-cell-th">No. Of Individual Trainings</div>
            <div class="table-cell-th">Total</div>
            <div class="table-cell-th">Pending</div>
            <div class="table-cell-th">Completed</div>
            <div class="table-cell-th">Failed</div>
            <div class="table-cell-th">Scheduled</div>
            <div class="table-cell-th">Inprogress</div>
            <div class="table-cell-th">Overdue</div>
            <div class="table-cell-th">Locked</div>
            <div class="table-cell-th">Failed Attempts</div>
            <div class="table-cell-th">Pass %</div>
          </div>
          <div class="table-row" *ngFor="let listOfUsersData of pagedItemsMain; let idx = index;">
            <div class="table-cell name clickable nameAlign" (click)="getDetailsOrg(listOfUsersData)"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.orgName}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetailsOrgUsers(listOfUsersData)"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.noOfUsers}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetailsOrgTrainings(listOfUsersData)"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.noOfIndividualTrainings}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetailsOrg(listOfUsersData)"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.pending}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.completed}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failed}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.scheduled}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.inprogress}}
            </div>
            <div class="table-cell clickable valueAlign">
              {{listOfUsersData.overdue}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.locked}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell valueAlign">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>
        <div *ngIf="collectionSize>10">
          <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <div class="col-2 col-md-6 d-flex justify-content-end align-items-center">
            </div>
            <nav class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
              1-{{ perPage }} of {{ collectionSize | number }}
              <ngb-pagination class="leftpadding" (pageChange)="setPageMain(pager.currentPage,$event)"
                [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                  {{perPage}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCallMain(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCallMain(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCallMain(50)">50</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="col-md-9" *ngIf="!notCompleted && selectedOption == 'Organization'">
        <div class="panel">
          <div class="detail-menu-container">
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu">
                    <img src="../../../assets/img/cr_module/total_requests.svg" width="16px" height="16px"
                      alt="Total" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{totalVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Total
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu pending_request">
                    <img src="../../../assets/img/tms/yet.svg" width="16px" height="16px" alt="Yet To Be Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{yetToBeAttemptedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Yet To Be
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu closed_request">
                    <img src="../../../assets/img/tms/att.svg" width="16px" height="16px" alt="Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{attemptedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Attempted
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu active_request">
                    <img src="../../../assets/img/tms/pass.svg" width="16px" height="16px"
                      alt="Completed At Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{completedAtAttemptedVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Completed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu overdue_request">
                    <img src="../../../assets/img/tms/fail.svg" width="16px" height="16px" alt="Failed At Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{failedAtAttemptedChartVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Failed
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu other_request">
                    <img src="../../../assets/img/tms/sch.svg" width="16px" height="16px"
                      alt="Scheduled At Attempted" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{scheduledAtAttemptedChartVal}}
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Scheduled
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="mini-chart-container" style="cursor: default;">
              <div class="d-flex gap-2">
                <div>
                  <div class="d-flex justify-content-center align-items-center requests_menu my_total_request">
                    <img src="../../../assets/img/tms/per.svg" width="16px" height="16px" alt="%" />
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <span class="chart-count">
                    {{passPerValForAll}} %
                  </span>
                  <span class="d-flex px-1">
                    <span class="chart-text me-2">
                      Pass
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-header">
            <div class="table-cell-th name">Organization Name</div>
            <div class="table-cell-th">No. Of Users</div>
            <div class="table-cell-th">No. Of Individual Trainings</div>
            <div class="table-cell-th">Total</div>
            <div class="table-cell-th">Yet To Be Attempted</div>
            <div class="table-cell-th">Attempted</div>
            <div class="table-cell-th">Completed</div>
            <div class="table-cell-th">Failed</div>
            <div class="table-cell-th">Scheduled</div>
            <div class="table-cell-th">Failed Attempts</div>
            <div class="table-cell-th">Pass %</div>
          </div>
          <div class="table-row" *ngFor="let listOfUsersData of pagedItemsMain; let idx = index;">
            <div class="table-cell name clickable nameAlign" (click)="getDetailsOrg(listOfUsersData)"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.orgName}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetailsOrgUsers(listOfUsersData)"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.noOfUsers}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetailsOrgTrainings(listOfUsersData)"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.noOfIndividualTrainings}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetailsOrg(listOfUsersData)"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.yetToBeAttempted}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.attempted}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.completedAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failedAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.scheduledAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell valueAlign">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>

        <div *ngIf="collectionSize>10">
          <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <div class="col-2 col-md-6 d-flex justify-content-end align-items-center">
            </div>
            <nav class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">

              1-{{ perPage }} of {{ collectionSize | number }}
              <ngb-pagination class="leftpadding" (pageChange)="setPageMain(pager.currentPage,$event)"
                [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block leftpadding">
                <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
                  {{perPage}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCallMain(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCallMain(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCallMain(50)">50</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div id="chartContainerTMS" style="height: 250px; width: 100%;"></div>
      </div>
      <div class="col-md-12"
        *ngIf="selectedOption == 'Organization' && getOneQmsUsersTrainingsRepVwTrainingCountByOr.length>0">
        <div class="menu-container">
          <div class="row menu-row-container">
            <div class="col-sm-6 gridName-container">
              <span class="tms-reports_title">No. Of Individual Trainings</span>
            </div>
            <div class="col-sm-5 action-buttons-container" style="margin-left: 59%;margin-top: -27px;">
              <div (click)="openReportPopupOrgInd()" (keydown.enter)="focusSearch('focus-Logo-search')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:bule"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-header">
            <div class="table-cell-th name">Organization Name</div>
            <div class="table-cell-th name" style="min-width: 200px;">Training Name</div>
            <div class="table-cell-th">Version</div>
            <div class="table-cell-th">Total</div>
            <div class="table-cell-th">Yet To Be Attempted</div>
            <div class="table-cell-th">Attempted</div>
            <div class="table-cell-th">Completed</div>
            <div class="table-cell-th">Failed</div>
            <div class="table-cell-th">Scheduled</div>
            <div class="table-cell-th">Failed Attempts</div>
            <div class="table-cell-th">Pass %</div>
          </div>
          <div class="table-row" *ngFor="let listOfUsersData of pagedItems3rd; let idx = index;">
            <div class="table-cell name nameAlign">
              {{listOfUsersData.orgName}}
            </div>
            <div class="table-cell clickable nameAlign" [title]="listOfUsersData.trainingName" style="min-width: 200px;"
              (click)="getDetailsOrgTraining(listOfUsersData,'All','training')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.trainingName}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.version}}
            </div>
            <div class="table-cell clickable valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'All','training')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'YET_TO_BE_ATTEMPTED','training')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.yetToBeAttempted}}
            </div>
            <div class="table-cell valueAlign" (click)="getDetailsOrgTraining(listOfUsersData,'ATTEMPTED','training')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.attempted}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'COMPLETED_AT_ATTEMPTED_CHART','training')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.completedAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'FAILED_AT_ATTEMPTED_CHART','training')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.failedAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'SCHEDULED_AT_ATTEMPTED_CHART','training')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.scheduledAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell valueAlign">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>
        <div *ngIf="collectionSize3rd > 10">
          <div class="row border-top mt-1 width-cheat small paginationCell justify-content-center">
            <nav class="col-auto d-flex justify-content-center align-items-center" aria-labelledby=" ">
              <span class="mr-2">1-{{ perPage3rd }} of {{ collectionSize3rd | number }}</span>
              <ngb-pagination class="mx-2" (pageChange)="setPage3rd(pager3rd.currentPage,$event)" [disabled]="false"
                [collectionSize]="pager3rd.totalItems" [(page)]="pager3rd.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage3rd" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block">
                <button class="btn btn-primary btn-sm mr-1" ngbDropdownToggle>
                  {{perPage3rd}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCall3rd(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCall3rd(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCall3rd(50)">50</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="col-md-12"
        *ngIf="selectedOption == 'Organization' && getOneQmsUsersTrainingsRepVwUserCountByor.length>0">
        <div class="menu-container">
          <div class="row menu-row-container">
            <div class="col-sm-6 gridName-container">
              <span class="tms-reports_title">No. Of Users</span>
            </div>
            <div class="col-sm-5 action-buttons-container" style="margin-left: 59%;margin-top: -27px;">
              <div (click)="openReportPopupOrgMain()" (keydown.enter)="focusSearch('focus-Logo-search')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:bule"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <div class="table-header">
            <div class="table-cell-th name" style="min-width: 200px;">User Name</div>
            <div class="table-cell-th">Total</div>
            <div class="table-cell-th">Yet To Be Attempted</div>
            <div class="table-cell-th">Attempted</div>
            <div class="table-cell-th">Completed</div>
            <div class="table-cell-th">Failed</div>
            <div class="table-cell-th">Scheduled</div>
            <div class="table-cell-th">Failed Attempts</div>
            <div class="table-cell-th">Pass %</div>
          </div>
          <div class="table-row" *ngFor="let listOfUsersData of pagedItems4th; let idx = index;">
            <div class="table-cell clickable nameAlign" style="min-width: 200px;" [title]="listOfUsersData.usrFullname"
              (click)="getDetailsOrgTraining(listOfUsersData,'All','users')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.usrFullname}}
            </div>
            <div class="table-cell clickable valueAlign" (click)="getDetailsOrgTraining(listOfUsersData,'All','users')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.total}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'YET_TO_BE_ATTEMPTED','users')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.yetToBeAttempted}}
            </div>
            <div class="table-cell valueAlign" (click)="getDetailsOrgTraining(listOfUsersData,'ATTEMPTED','users')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.attempted}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'COMPLETED_AT_ATTEMPTED_CHART','users')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.completedAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'FAILED_AT_ATTEMPTED_CHART','users')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.failedAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign"
              (click)="getDetailsOrgTraining(listOfUsersData,'SCHEDULED_AT_ATTEMPTED_CHART','users')"
              (keydown.enter)="focusSearch('focus-Logo-search')">
              {{listOfUsersData.scheduledAtAttemptedChart}}
            </div>
            <div class="table-cell valueAlign">
              {{listOfUsersData.failedAttempts}}
            </div>
            <div class="table-cell valueAlign">
              {{(listOfUsersData.completed / listOfUsersData.total * 100).toFixed(1)}}%
            </div>
          </div>
        </div>
        <div *ngIf="collectionSize4th > 10">
          <div class="row border-top mt-1 width-cheat small paginationCell justify-content-center">
            <nav class="col-auto d-flex justify-content-center align-items-center mt-2" aria-labelledby=" ">
              <span class="mr-2">1-{{ perPage4th }} of {{ collectionSize4th | number }}</span>
              <ngb-pagination class="mx-2" (pageChange)="setPage4th(pager4th.currentPage,$event)" [disabled]="false"
                [collectionSize]="pager4th.totalItems" [(page)]="pager4th.currentPage" [maxSize]="maxSize"
                [rotate]="true" [pageSize]="perPage4th" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
              <div ngbDropdown class="d-inline-block">
                <button class="btn btn-primary btn-sm mr-1" ngbDropdownToggle>
                  {{perPage4th}}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCall4th(10)">10</button>
                  <button ngbDropdownItem (click)="paginationCall4th(20)">20</button>
                  <button ngbDropdownItem (click)="paginationCall4th(50)">50</button>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>


  <br>
  <div class="table-container" *ngIf="totalVal == 0 ">
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;font-size: 24px;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 275px; height: 200px;"> </span>
  </div>
  <div class="row table-container" style="margin-top:30px;" *ngIf="getOneQmsUsersTrainingsRepVw.length>0">
    <div class="menu-container">
      <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container">
          <span class="tms-reports_title">{{selectedStatus}}</span>
        </div>

      </div>
    </div>
    <div class="col-md-12">
      <div class="panel">
        <div class="panel-body cetmf-panel-body" style="padding: 3px;">
          <div class="row" *ngIf="pagedItemsSecond.length>0">
            <div class="col-7"></div>
            <div class="col-1"></div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="openReportPopupTMS('Excel')" (keydown.enter)="focusSearch('focus-Logo-search')">
              <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
              <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
              (click)="openReportPopupTMS('Pdf')" (keydown.enter)="focusSearch('focus-Logo-search')">
              <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
              <span class="reload_text text-white">PDF Report</span>
            </div>
          </div>
          &nbsp;&nbsp;
          <table>
            <thead>
              <th>
                <input type="checkbox" style="zoom: 1.2;  width: 35px;" [(ngModel)]="selectAllChecked"
                  (change)="selectAllRows()" />
              </th>
              <th>
                <span>User Name</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('usrFullname', $event,'s')" />
              </th>
              <th>
                <span>Training Name</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('trainingName', $event,'s')" />
              </th>

              <th>
                <span>Version</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('version', $event,'n')" />
              </th>
              <th>
                <span>Training Code</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('trainingCode', $event,'s')" />
              </th>
              <th>
                <span>Training Type</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('trainingType', $event,'s')" />
              </th>

              <th style="width:80px ">
                <span>Group Name</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('groupName', $event,'s')" />
              </th>
              <th style="width:180px">
                <span>Trainer Name</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('trainerName', $event,'s')" />

              </th>
              <th style="width:180px ">
                <span>Status</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('status', $event,'s')" />
              </th>
              <th style="width:180px">
                <span>Reason For Not Considered At Report</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('reasonForNotConsideredAtReport', $event,'s')" />
              </th>
              <th style="width:80px ">
                <span>Is User Active</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('isUserActive', $event,'s')" />
              </th>
              <th style="width:180px ">
                <span>Designation Code</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('designationCode', $event,'s')" />
              </th>
              <th style="width:180px ">
                <span>Department Code</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('department', $event,'s')" />
              </th>
              <th style="width:180px">
                <span>Manager Name</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('managerName', $event,'s')" />
              </th>
              <th style="width:80px ">
                <span>User Training Status</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('userTrainingStatus', $event,'s')" />
              </th>
              <th style="width:80px">
                <span>Scheduled Training Status</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('scheduledTrainingStatus', $event,'s')" />
              </th>
              <th style="width:80px ">
                <span>Expiry Date</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('expiryDate', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Due Date</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('dueDate', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Training Assigned On</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('trainingAssignedOn', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>User Training Assigned On</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('userTrainingAssignedOnStr', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Intimation Sent On</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('intimationSentOn', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Started On</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('startedOn', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Completed On</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('completedOn', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Reminder Sent On</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('reminderSentOn', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Escalation Sent On</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('escalationSentOn', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Locked On</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('lockedOn', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Failed Lock RM Approved On</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('failedLockRmApprovedOn', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Overdue Lock QA Approved On</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('overdueLockQaApprovedOn', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Overdue Lock RM Approved On</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('overdueLockRmApprovedOn', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Start Date</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('startDate', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>End Date</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('endDate', $event,'d')" />
              </th>
              <th style="width:80px ">
                <span>Comments</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('comments', $event,'s')" />
              </th>



              <th style="width:80px ">
                <span>Failed Attempts</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('failedAttempts', $event,'n')" />
              </th>
              <th style="width:80px ">
                <span>Final Score</span>
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter1('finalScore', $event,'n')" />
              </th>
            </thead>
            <tbody>
              <tr *ngIf="pagedItemsSecond.length === 0">
                <td class="row-data text-center" colspan="15">No records found</td>
              </tr>
              <tr *ngFor="let listOfUsersData of pagedItemsSecond; let idx = index;">
                <td>
                  <input type="checkbox" style="zoom: 1.2; width: 35px; " [(ngModel)]="listOfUsersData.isSelected"
                    (change)="childCheckboxChanged()" />
                </td>
                <td class="row-data" style="color: black;  min-width:200px;">
                  {{listOfUsersData.usrFullname}}</td>
                <td class="row-data" style="color: black; min-width:350px;   ">
                  {{listOfUsersData.trainingName}}</td>
                <td style="text-align:right; color: black; width:80px">
                  {{listOfUsersData.version}}</td>
                <td class="row-data" style="color: black;  min-width:200px; ">
                  {{listOfUsersData.trainingCode}}</td>
                <td class="row-data" style="color: black;  min-width:200px; ">
                  {{listOfUsersData.trainingType}}</td>
                <td class="row-data" style="color: black">
                  {{listOfUsersData.groupName}}</td>
                <td class="row-data" style="color: black;">
                  {{listOfUsersData.trainerName}}</td>
                <td class="row-data" style="color: black;">
                  {{listOfUsersData.status}}</td>
                <td class="row-data" style="color: black;">
                  {{listOfUsersData.reasonForNotConsideredAtReport}}</td>
                <td class="row-data">
                  <div class="icon-container">
                    <img *ngIf="listOfUsersData.isUserActive === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                      height="20" alt="Access granted symbol">
                    <img *ngIf="listOfUsersData.isUserActive === 'N'" src="../../assets/img/noAcessSymbol.svg"
                      width="20" height="20" alt="Access granted symbol">
                  </div>
                </td>
                <td class="row-data" style="color: black;">
                  {{listOfUsersData.designationCode}}</td>
                <td class="row-data" style="color: black;">
                  {{listOfUsersData.departmentCode}}</td>
                <td class="row-data" style="color: black;">
                  {{listOfUsersData.managerUsername}}</td>
                <td class="row-data" style="color: black">
                  {{listOfUsersData.userTrainingStatus}}</td>
                <td class="row-data" style="color: black">
                  {{listOfUsersData.scheduledTrainingStatus}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.expiryDateStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.dueDateStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.trainingAssignedOnStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.userTrainingAssignedOnStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.intimationSentOnStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.startedOnStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.completedOnStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.reminderSentOnStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.escalationSentOnStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.lockedOnStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.failedLockRmApprovedOnStr}}</td>
                <td class="row-data" style=" text-align:center; color: black">
                  {{listOfUsersData.overdueLockQaApprovedOnStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.overdueLockRmApprovedOnStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.startDateStr}}</td>
                <td class="row-data" style="text-align:center;color: black">
                  {{listOfUsersData.endDateStr}}</td>
                <td class="row-data" style="color: black">
                  {{listOfUsersData.comments}}</td>

                <td class="row-data" style=" text-align:right; color: black">
                  {{listOfUsersData.failedAttempts}}</td>
                <td class="row-data" style="text-align:right ; color: black">
                  {{listOfUsersData.finalScore}}</td>
                <td class="sticky-col first-col">
                  <div class="action-icons">
                    <i class="fas fa-download" title="Certificate Download" style="margin-left: 5px;"
                      *ngIf="listOfUsersData.status=='Completed'" (click)="cerDownload(listOfUsersData)"
                      (keydown.enter)="focusSearch('focus-Logo-search')"></i>&nbsp;
                    <i class="fas fa-cloud-download-alt" title="Evidence Download" style="margin-left: 5px;"
                      *ngIf="listOfUsersData.evidenceDocId!=null && listOfUsersData.evidenceDocId!=''"
                      (click)="eviDownload(listOfUsersData)" (keydown.enter)="focusSearch('focus-Logo-search')"></i>
                    <i class="fa-solid fa-clipboard" title="Audit Trail" style="margin-left: 5px;"
                      *ngIf="message.isAuditTrailUser" (click)="openAuditTrail(listOfUsersData)"
                      (keydown.enter)="focusSearch('focus-Logo-search')"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-center">
            <div class="width-cheat small paginationCell">
              <div class="d-flex align-items-center gap-3">
                <div class="pagination_text mt-3">
                  {{ showingRowsText }}
                  1-{{ perPageSecond }} of {{ collectionSizeSecond | number }}
                </div>
                <div>
                  <ngb-pagination class="leftpadding" (pageChange)="setPageSecond(pagerSecond.currentPage,$event)"
                    [disabled]="false" [collectionSize]="pagerSecond.totalItems" [(page)]="pagerSecond.currentPage"
                    [maxSize]="maxSize" [rotate]="true" [pageSize]="perPageSecond" [ellipses]="false"
                    [boundaryLinks]="true" size="sm">
                  </ngb-pagination>
                </div>
                <div ngbDropdown class="mt-3">
                  <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
                    {{ perPageSecond }}
                    <i class="ms-1 fa-solid fa-chevron-down"></i>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem (click)="paginationCallSecond(10)">10</button>
                    <button ngbDropdownItem (click)="paginationCallSecond(20)">20</button>
                    <button ngbDropdownItem (click)="paginationCallSecond(50)">50</button>
                  </div>
                  per page
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>



<div class="row" *ngIf="showCharts">
  <div class="row">
    <div class="col-md-6" *ngIf="dmsCountList.length>0">
      <div class="border rounded-4 p-2 mb-3">
        <canvasjs-chart [options]="chartOptionsForDMSCount" [styles]="{width: '100%', height:'250px'}"
          (dblclick)="chartDoubleClick(1)"></canvasjs-chart>
      </div>
    </div>
    <div class="col-md-6" *ngIf="dmsCountList.length==0">
      <div class="border rounded-4 p-2 mb-3">
        <label for="count"
          style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins',sans-serif;color:#0F3659;"><b>DMS
            Count</b></label>
        <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
          <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 275px; height: 200px;"></span>
      </div>
    </div>

    <div class="col-md-6" *ngIf="statusList.length>0">
      <div class="border rounded-4 p-2 mb-3">
        <canvasjs-chart [options]="chartOptionsForStatus" [styles]="{width: '100%', height:'250px'}"
          (dblclick)="chartDoubleClick(2)"></canvasjs-chart>
      </div>
    </div>
    <div class="col-md-6" *ngIf="statusList.length==0">
      <div class="border rounded-4 p-2 mb-3">
        <label for="Status"
          style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins',sans-serif;color:#0F3659;"><b>Status</b></label>
        <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
          <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 275px; height: 200px;"></span>
      </div>
    </div>


    <div class="col-md-12" *ngIf="typeNameList.length > 0">
      <div class="border rounded-4 p-2 mb-3 chart-container" style="width: 1350px; overflow-x: auto;">
        <canvasjs-chart [options]="chartOptionsForDocType"
          [styles]="{ width: typeNameList.length > 20 ? '2500px' : '100%', height: '250px' }"
          (dblclick)="chartDoubleClick(3)">
        </canvasjs-chart>
      </div>
    </div>

    <div class="col-md-12" *ngIf="typeNameList.length==0">
      <div class="border rounded-4 p-2 mb-3">
        <label for=" "
          style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins',sans-serif;color:#0F3659;"><b>Document
            Type</b></label>
        <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
          <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 275px; height: 200px;"></span>
      </div>
    </div>
  </div>
</div>

<ng-template #reportPopupForZoom>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupForZoomFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Documents Report</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="row">
    <div class="col-md-12" *ngIf="clickedChartVal==1">
      <canvasjs-chart [options]="chartOptionsForDMSCountZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12" *ngIf="clickedChartVal==2">
      <canvasjs-chart [options]="chartOptionsForStatusZoom" [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 chart-container" *ngIf="clickedChartVal==3">
      <canvasjs-chart [options]="chartOptionsForDocTypeZoom"
        [styles]="{width:chartWith, height:'250px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="table-container">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="focusSearch('focus-Logo-search')">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead>
          <th style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          </th>
          <th id="grid-header-container"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
            class="sticky-dynamic-col1 dynamic-table-header-style" (mouseover)="cssfunction(0)">
            <div *ngIf="oneQmsUsersDataForTable1Data.fieldColumnarray != 'Prim Identifier'">
              <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter7(columnLists.columnsListarray[ix],$event,'s')">
              </div>
            </div>
          </th>
        </thead>
        <tr *ngIf="pagedItemsDMS1.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr *ngFor="let list of pagedItemsDMS1  | searchFilter : searchValue; let idx = index;">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap'}" [ngClass]="{'hidden-column': key.columnsListarray === 'PRIM_IDENTIFIER'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" alt=" " src="../../assets/img/accessSymbol.svg" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" alt=" " src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20">
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData1(list,key.columnsListarray)">
                  <img src="../../../assets/img/view.png" width="12px" height="12px" alt="download">
                  <span class="ms-1" style="color:azure">View</span>
                </button>
              </div>
            </span>
            <span
              *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
              list[key.columnsListarray]}}</span>
            <span *ngIf="key.dataType=='DATE' && key.columnsListarray=='EFFECTIVE_DATE'">{{ list[key.columnsListarray] |
              date : (appService.getOneQmsDateFormat)}}</span>
            <span *ngIf="key.dataType=='DATE'&& key.columnsListarray=='EXPIRATION_DATE'">{{ list[key.columnsListarray] |
              date : (appService.getOneQmsDateFormat)}}</span>
            <span
              *ngIf="key.dataType=='DATE'&& key.columnsListarray!='EFFECTIVE_DATE' && key.columnsListarray!='EXPIRATION_DATE'">{{
              list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" "></nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPageDMS1(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic">
            <button ngbDropdownItem (click)="paginationCallDMS1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCallDMS1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCallDMS1(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
  <!--<div class="table-container" *ngIf="showReportFlagValue=='1'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <table class="dynamic-table-container">
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Axis Value</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('axisValue', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Intervals</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('intervals', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Doc Container</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('docContainer', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Document Type Name</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('documentTypeName', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Document No.</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('documentNo', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Document Name</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('documentName', $event,'s')" />
        </div>
      </th>

      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Version</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('version', $event,'n')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Status</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('status', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Effective Date</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('effectiveDateStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Expiration Date</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('expirationDateStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Associated Document ID</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('associatedDocumentNo', $event,'n')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Associated Document From Version</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('associatedDocumentFromVersion', $event,'n')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Associated Document To Version</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('associatedDocumentToVersion', $event,'n')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Revision History</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('revisionHistory', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>CR Details</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('crDetails', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Document Description</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('documentDescription', $event,'s')" />
        </div>
      </th>

      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Folder Name</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('folderName', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Folder Path</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('folderPath', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Folder Status</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('folderStatus', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>All Parent Folder Status</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('allParentFolderStatus', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Distributed Folder</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isDistributedFolder', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Document Type Code</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('documentTypeCode', $event,'s')" />
        </div>
      </th>

      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Associated Document Type</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isAssociatedDocumentType', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Belongs To Individual</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('belongsToIndividual', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Assignable At Trainings</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('assignableAtTrainings', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Amendement Doc Type</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isAmendementDocType', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Associated Doc To Follow Same Expiry</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('associatedDocToFollowSameExpiry', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Belongs To User</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('belongsUserName', $event,'s')" />
        </div>
      </th>

      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Checkout Flag</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('checkoutFlag', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Checkedout On</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('checkedOutOn', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Checkedout By User</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('checkedoutByUser', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Checkedin On</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('checkedinOnStr', $event,'n')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Checkedin By User</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('checkedinByUser', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Checkinout Comments</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('checkinoutComments', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Latest Version</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isLatestVersion', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Latest Published Version</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isLatestPublishedVersion', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Blinded</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('isBlinded', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Blinded By</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('blindedByName', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Blinded On</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('blindedOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Unblinded By</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('unblindedByName', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Unblinded On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('unblindedOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Unblind Reason</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('unblindReason', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Published On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('publishedOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Published By</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('publishedByName', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Extension In Progress</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isExtensionInProgress', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Withdrawal In Progress</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isWithDrawalInProgress', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Amendment In Progress</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isAmendmentInProgress', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>No. Of Completed Extension</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('noOfCompletedExtension', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>No. Of Completed Amendment</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('noOfCompletedAmendment', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Reason For Status Change</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('reasonForStatusChange', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Update Reason</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('updateReason', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Last Action On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('lastActionOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Last Action By</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('lastActionBy', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Last Action Comments</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('lastActionComments', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Created On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('createdOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Created By User</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('createdByUser', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Updated On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('updatedOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Updated By User</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('updatedByUser', $event,'s')" />
        </div>
      </th>
      <th class="sticky-col first-col"></th>
      <tr *ngIf="pagedItems.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
        <td class="row-data">{{ listOfUsersData.axisValue }}</td>
        <td class="row-data">{{ listOfUsersData.intervals }}</td>
        <td class="row-data">{{ listOfUsersData.docContainer }}</td>
        <td class="row-data">{{ listOfUsersData.documentTypeName }}</td>
        <td class="row-data">{{ listOfUsersData.documentNo }}</td>
        <td class="row-data">{{ listOfUsersData.documentName }}</td>
        <td class="row-data">{{ listOfUsersData.version }}</td>
        <td class="row-data">{{ listOfUsersData.status }}</td>
        <td class="row-data">{{ listOfUsersData.effectiveDateStr}}</td>
        <td class="row-data">{{ listOfUsersData.expirationDateStr}}</td>
        <td class="row-data">{{ listOfUsersData.associatedDocumentNo }}</td>
        <td class="row-data">{{ listOfUsersData.associatedDocumentFromVersion }}</td>
        <td class="row-data">{{ listOfUsersData.associatedDocumentToVersion }}</td>
        <td class="row-data">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="getClobData(listOfUsersData,'REVISION_HISTORY',listOfUsersData.revisionHistory,'DMS_INTERVALS_REP_VW')">
              <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
              <span class="ms-1" style="color:azure;">View</span>
            </button>
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.crDetails }}</td>
        <td class="row-data">{{ listOfUsersData.documentDescription }}</td>
        <td class="row-data">{{ listOfUsersData.folderName }}</td>
        <td class="row-data">{{ listOfUsersData.folderPath }}</td>
        <td class="row-data">{{ listOfUsersData.folderStatus }}</td>
        <td class="row-data">{{ listOfUsersData.allParentFolderStatus }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isDistributedFolder === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isDistributedFolder === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.documentTypeCode }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isAssociatedDocumentType === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isAssociatedDocumentType === 'N'" src="../../assets/img/noAcessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.belongsToIndividual === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.belongsToIndividual === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.assignableAtTrainings === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.assignableAtTrainings === 'N'" src="../../assets/img/noAcessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isAmendementDocType === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isAmendementDocType === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.associatedDocToFollowSameExpiry === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.associatedDocToFollowSameExpiry === 'N'"
              src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.belongsUserName }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.checkoutFlag === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.checkoutFlag === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.checkedoutOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.checkedoutByUser}}</td>
        <td class="row-data">{{ listOfUsersData.checkedinOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.checkedinByUser }}</td>
        <td class="row-data">{{ listOfUsersData.checkinoutComments }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isLatestVersion === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isLatestVersion === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isLatestPublishedVersion === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isLatestPublishedVersion === 'N'" src="../../assets/img/noAcessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isBlinded === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isBlinded === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.blindedByName }}</td>
        <td class="row-data">{{ listOfUsersData.blindedOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.unblindedByName }}</td>
        <td class="row-data">{{ listOfUsersData.unblindedOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.unblindReason }}</td>
        <td class="row-data">{{ listOfUsersData.publishedOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.publishedByName }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isExtensionInProgress === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img
              *ngIf="listOfUsersData.isExtensionInProgress === 'N' ||listOfUsersData.isExtensionInProgress === '' ||listOfUsersData.isExtensionInProgress ===null||listOfUsersData.isExtensionInProgress ==='null'"
              src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isWithdrawalInProgress === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isWithdrawalInProgress === 'N'" src="../../assets/img/noAcessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isAmendmentInProgress === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img
              *ngIf="listOfUsersData.isAmendmentInProgress === 'N' ||listOfUsersData.isAmendmentInProgress === '' ||listOfUsersData.isAmendmentInProgress ===null||listOfUsersData.isAmendmentInProgress ==='null'"
              src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.noOfCompletedExtension }}</td>
        <td class="row-data">{{ listOfUsersData.noOfCompletedAmendment }}</td>
        <td class="row-data">{{ listOfUsersData.reasonForStatusChange }}</td>
        <td class="row-data">{{ listOfUsersData.updateReason }}</td>
        <td class="row-data">{{ listOfUsersData.lastActionOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.lastActionByUser }}</td>
        <td class="row-data">{{ listOfUsersData.lastActionComments }}</td>
        <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
        <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
      </tr>
    </table>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>-->
</ng-template>

<ng-template #reportPopupForDMSChart>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupFunctionForDmsChart()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">{{clickedType}} : {{clickedVal}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="table-container">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="focusSearch('focus-Logo-search')">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead>
          <th style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          </th>
          <th id="grid-header-container"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
            class="sticky-dynamic-col1 dynamic-table-header-style" (mouseover)="cssfunction(0)">
            <div *ngIf="oneQmsUsersDataForTable1Data.fieldColumnarray != 'Prim Identifier'">
              <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter7(columnLists.columnsListarray[ix],$event,'s')">
              </div>
            </div>
          </th>
        </thead>
        <tr *ngIf="pagedItemsDMS1.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr *ngFor="let list of pagedItemsDMS1  | searchFilter : searchValue; let idx = index;">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap'}" [ngClass]="{'hidden-column': key.columnsListarray === 'PRIM_IDENTIFIER'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" alt=" " src="../../assets/img/accessSymbol.svg" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" alt=" " src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20">
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData1(list,key.columnsListarray)">
                  <img src="../../../assets/img/view.png" width="12px" height="12px" alt="download">
                  <span class="ms-1" style="color:azure">View</span>
                </button>
              </div>
            </span>
            <span
              *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
              list[key.columnsListarray]}}</span>
            <span *ngIf="key.dataType=='DATE' && key.columnsListarray=='EFFECTIVE_DATE'">{{ list[key.columnsListarray] |
              date : (appService.getOneQmsDateFormat)}}</span>
            <span *ngIf="key.dataType=='DATE'&& key.columnsListarray=='EXPIRATION_DATE'">{{ list[key.columnsListarray] |
              date : (appService.getOneQmsDateFormat)}}</span>
            <span
              *ngIf="key.dataType=='DATE'&& key.columnsListarray!='EFFECTIVE_DATE' && key.columnsListarray!='EXPIRATION_DATE'">{{
              list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" "></nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPageDMS1(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic">
            <button ngbDropdownItem (click)="paginationCallDMS1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCallDMS1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCallDMS1(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>


  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunctionForDmsChart()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<div class="table-container"
  *ngIf="showNoRecordFoundInventry && onSelectedOptionForDMS=='Inventory' && selectedReportType == 'Documents'">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold; font-size: 24px;">
    <img src="../../assets/img/empty-box.png" alt="Group Intervals"
      style="width: 100px; height: 100px; margin-right: 10px;">
    <br> No record found
  </span>
</div>
<div class="row"
  *ngIf="tmsUserTrainingsRepVwDataForGrid.length>0 && onSelectedOptionForDMS=='Inventory' && selectedReportType == 'Documents'">
  <div class="table-container">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="focusSearch('focus-Logo-search')">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead>
          <th style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          </th>
          <th id="grid-header-container"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
            class="sticky-dynamic-col1 dynamic-table-header-style" (mouseover)="cssfunction(0)">
            <div *ngIf="oneQmsUsersDataForTable1Data.fieldColumnarray != 'Prim Identifier'">
              <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter7(columnLists.columnsListarray[ix],$event,'s')">
              </div>
            </div>
          </th>
        </thead>
        <tr *ngIf="pagedItemsDMS1.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr *ngFor="let list of pagedItemsDMS1  | searchFilter : searchValue; let idx = index;">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap'}" [ngClass]="{'hidden-column': key.columnsListarray === 'PRIM_IDENTIFIER'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" alt=" " src="../../assets/img/accessSymbol.svg" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" alt=" " src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20">
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData1(list,key.columnsListarray)">
                  <img src="../../../assets/img/view.png" width="12px" height="12px" alt="download">
                  <span class="ms-1" style="color:azure">View</span>
                </button>
              </div>
            </span>
            <span
              *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
              list[key.columnsListarray]}}</span>
            <span *ngIf="key.dataType=='DATE' && key.columnsListarray=='EFFECTIVE_DATE'">{{ list[key.columnsListarray] |
              date : (appService.getOneQmsDateFormat)}}</span>
            <span *ngIf="key.dataType=='DATE'&& key.columnsListarray=='EXPIRATION_DATE'">{{ list[key.columnsListarray] |
              date : (appService.getOneQmsDateFormat)}}</span>
            <span
              *ngIf="key.dataType=='DATE'&& key.columnsListarray!='EFFECTIVE_DATE' && key.columnsListarray!='EXPIRATION_DATE'">{{list[key.columnsListarray]}}</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" "></nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPageDMS1(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic">
            <button ngbDropdownItem (click)="paginationCallDMS1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCallDMS1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCallDMS1(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
</div>

<div class="table-container"
  *ngIf="showNoRecordFoundMasterIndex  && onSelectedOptionForDMS=='Master Index' && selectedReportType == 'Documents'">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold; font-size: 24px;">
    <img src="../../assets/img/empty-box.png" alt="Group Intervals"
      style="width: 100px; height: 100px; margin-right: 10px;">
    <br> No record found
  </span>
</div>
<div class="table-container"
  *ngIf="tableReportDataList.length>0 && onSelectedOptionForDMS=='Master Index' && selectedReportType == 'Documents'">
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="focusSearch('focus-Logo-search')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="focusSearch('focus-Logo-search')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document Type Name</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('documentTypeName', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document No</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('documentNo', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document Name</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('documentName', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Version</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('version', $event,'n')" />
          </div>
        </th>

        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Effective Date</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('effectiveDate', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Expiration Date</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('expirationDate', $event,'d')" />
          </div>
        </th>
        <th class="sticky-col first-col"></th>
      </thead>
      <tr *ngIf="pagedItems1.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
        <td class="row-data">{{ listOfUsersData.documentTypeName}}</td>
        <td class="row-data">{{ listOfUsersData.documentNo}}</td>
        <td class="row-data">{{ listOfUsersData.documentName}}</td>
        <td class="row-data">{{ listOfUsersData.version}}</td>
        <td class="row-data">{{ listOfUsersData.effectiveDateStr}}</td>
        <td class="row-data">{{ listOfUsersData.expirationDateStr}}</td>
      </tr>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPageDMS2(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCallDMS2(10)">10</button>
            <button ngbDropdownItem (click)="paginationCallDMS2(20)">20</button>
            <button ngbDropdownItem (click)="paginationCallDMS2(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #reportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">{{clickedVal}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="table-container" *ngIf="selectedType=='Activity'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Organization Full Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('orgLongName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Organization Short Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('orgShortName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Module</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('module', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Department Head User Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('departmentHeadUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Group Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('groupName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Group Active</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isGroupActive', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Temp Task No</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('tempTaskNo', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Task ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('taskId', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Task Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('taskType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected To Be Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedToBeStartedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expected Closure On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expectedClosureOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Overdue</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('overdue', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Chart Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('chartStatus', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stage Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stageName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Short Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('shortDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Dept Code</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('deptCode', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Dept Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('deptName', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf=="selectedModules!='AU'">
            <span>Requested At</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('requestedAt', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style" *ngIf=="selectedModules!='AU'">
            <span>Core Business Area Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('coreBusinessAreaName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Initiator Name/Planner Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('initiatorName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Initiator Full Name/Planner Full Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('initiatorFullname', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Owner Name/Lead Auditor</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('ownerName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Owner Full Name/Lead Full Auditor</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('ownerFullname', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('description', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Acceptor / Schedule Approved By Fullname </span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('qaAcceptorFullname', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>QA Approver/Plan Approved By Fullname</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('qaFullname', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Investigator Fullname</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('investigatorFullname', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Started On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('startedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Completed On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('completedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reopen or Revoked On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('reopenOrRevokedOn', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final No Generated</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalNoGenerated', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Q and A Required</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isQAndAReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Effectiveness Check Required</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('effectivenessCheckReqd', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Investigation Required</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('investigationRequired', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Final Risk Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('finalRiskStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Stop Reminders</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('stopReminders', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action From Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionFromStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionOn', $event,'d')" />
            </div>
          </th>
        </thead>

        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
          <td class="row-data">{{ listOfUsersData.orgLongName }}</td>
          <td class="row-data">{{ listOfUsersData.orgShortName }}</td>
          <td class="row-data">{{ listOfUsersData.module }}</td>
          <td class="row-data">{{ listOfUsersData.departmentHeadUserName }}</td>
          <td class="row-data">{{ listOfUsersData.groupName }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isGroupActive === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isGroupActive === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.tempTaskNo }}</td>
          <td class="row-data">{{ listOfUsersData.taskId }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.taskType }}</td>
          <td class="row-data">{{ listOfUsersData.expectedToBeStartedOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.expcetedClosureOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.overdue }}</td>
          <td class="row-data">{{ listOfUsersData.chartStatus }}</td>
          <td class="row-data">{{ listOfUsersData.stageName }}</td>
          <td class="row-data">{{ listOfUsersData.shortDescription }}</td>
          <td class="row-data">{{ listOfUsersData.deptCode }}</td>
          <td class="row-data">{{ listOfUsersData.deptName }}</td>
          <td class="row-data" *ngIf=="selectedModules!='AU'">{{ listOfUsersData.requestedAt }} sdvsd</td>
          <td class="row-data" *ngIf=="selectedModules!='AU'">{{ listOfUsersData.coreBusinessAreaName }}sd</td>
          <td class="row-data">{{ listOfUsersData.initiatorName }}</td>
          <td class="row-data">{{ listOfUsersData.initiatorFullname }}</td>
          <td class="row-data">{{ listOfUsersData.ownerName }}</td>
          <td class="row-data">{{ listOfUsersData.ownerFullname }}</td>
          <td class="row-data">{{ listOfUsersData.description }}</td>
          <td class="row-data">{{ listOfUsersData.qaAcceptorFullname }}</td>
          <td class="row-data">{{ listOfUsersData.qaFullname }}</td>
          <td class="row-data">{{ listOfUsersData.investigatorFullname }}</td>
          <td class="row-data">{{ listOfUsersData.createdOn | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">{{ listOfUsersData.startedOn | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">{{ listOfUsersData.completedOn | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">{{ listOfUsersData.reopenOrRevokedOn | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.finalNoGenerated === 'N' || listOfUsersData.finalNoGenerated === null"
                src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isQandaReqd === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isQandaReqd === 'N' || listOfUsersData.isQandaReqd === null"
                src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.effectivenessCheckReqd === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img
                *ngIf="listOfUsersData.effectivenessCheckReqd === 'N' || listOfUsersData.effectivenessCheckReqd === null"
                src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.investigationRequired === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img
                *ngIf="listOfUsersData.investigationRequired === 'N' || listOfUsersData.investigationRequired === null"
                src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.finalRiskStatus }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.stopReminders === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.stopReminders === 'N' || listOfUsersData.stopReminders === null"
                src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.lastActionFromStatus }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionOn | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container" *ngIf="selectedType=='Action' || selectedType=='Finding'">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorderActionFindings()"
        (keydown.enter)="focusSearch('focus-Logo-search')">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th id="grid-header-container"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
            class="sticky-dynamic-col1 dynamic-table-header-style">
            <div>
              <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter33(columnLists.columnsListarray[ix],$event)">
              </div>
            </div>
          </th>
        </thead>

        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
'text-overflow': 'ellipsis',
'white-space': 'nowrap'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" alt="" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" alt="" src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20">
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData3(list,key.columnsListarray)">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="key.columnsListarray=='QMS_ROLES'" title="{{ list[key.columnsListarray] }}">
              {{ list[key.columnsListarray] }}</span>
            <span
              *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
              list[key.columnsListarray]}}</span>
            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPageAction(pager.currentPage,$event)"
              [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
              [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCallAction(10)">10</button>
              <button ngbDropdownItem (click)="paginationCallAction(20)">20</button>
              <button ngbDropdownItem (click)="paginationCallAction(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #reportPopup1>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupFunction1()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">{{clickedVal}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>

  <div class="table-container">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorderActionFindings()"
        (keydown.enter)="focusSearch('focus-Logo-search')">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopupQMS('Excel')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopupQMS('Pdf')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead style="z-index:9">
          <th id="grid-header-container"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
            class="sticky-dynamic-col1 dynamic-table-header-style">
            <div>
              <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter33(columnLists.columnsListarray[ix],$event)">
              </div>
            </div>
          </th>
        </thead>

        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
'text-overflow': 'ellipsis',
'white-space': 'nowrap'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" alt="" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" alt="" src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20">
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData3(list,key.columnsListarray)">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span *ngIf="key.columnsListarray=='QMS_ROLES'" title="{{ list[key.columnsListarray] }}">
              {{ list[key.columnsListarray] }}</span>
            <span
              *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
              list[key.columnsListarray]}}</span>
            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPageAction(pager.currentPage,$event)"
              [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
              [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCallAction(10)">10</button>
              <button ngbDropdownItem (click)="paginationCallAction(20)">20</button>
              <button ngbDropdownItem (click)="paginationCallAction(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunction1()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
    <label for="email" style="font-size: .7rem; font-weight: bold;">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 10 columns for a cleaner and more readable PDF
      </span>
    </label>
  </div>
  <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
    <div class="col-md-12" *ngIf="selectedColumns.length">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
        rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>
    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
      <div class="col-md-6">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes"
            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%;">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row mt-3" *ngIf="manuallyPicked">
      <div class="col-md-12">
        <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
        <!-- <mat-select id="select-tms-data" matInput multiple placeholder="Select" #pdfColumnVal
          [(ngModel)]="selectedColumns" (closed)="departmentSearchText1=''"
          (click)="focusSearch('focus-department-search5')" (keydown.enter)="focusSearch('focus-department-search5')">
          <input type="search" id="focus-department-search5" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText1" matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="pdfColumnSelection" (change)="toggleAllSelection1()">
              Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of excelPdf.dropDown | assessmentSearch : departmentSearchText1" [value]="item"
            (onSelectionChange)="onPDFSelect($event,item)">
            {{item}}
          </mat-option>
        </mat-select> -->
        <mat-select matInput multiple placeholder="Select" #pdfColumnVal [(ngModel)]="selectedColumns"
          (closed)="departmentSearchText1=''" (click)="focusSearch('focus-department-search5')"
          (keydown.enter)="focusSearch('focus-department-search5')">
          <input type="search" id="focus-department-search5" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText1" matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="pdfColumnSelection" (change)="toggleAllSelection1()">
              Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of  excelPdf.dropDown | multiAssessmentSearchPipe :departmentSearchText1"
            [value]="item" (onSelectionChange)="onPDFSelect($event,item)">
            {{ item }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Is Save Report?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="isSaveReport">
      <div class="col-sm-4">
        <label for="email">Report Name</label>
      </div>
      <div class="col-sm-8">
        <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
    </div>

  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions
    *ngIf="selectedReportType=='Quality' && selectedType=='Activity' && typeOfGrid!='dy'">
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions
    *ngIf="selectedReportType=='Quality' && selectedType=='Activity' && typeOfGrid=='dy'">
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReportActionFindings('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReportActionFindings('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions
    *ngIf="selectedType=='Action' || selectedType=='Finding'">
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReportActionFindings('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReportActionFindings('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions
    *ngIf="selectedReportType=='Trainings'">
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReportTMS('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReportTMS('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions
    *ngIf="selectedReportType=='Documents'">
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReportDMS('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReportDMS('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #excelPdfPopupOrg>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions
    *ngIf="selectedOption != 'Organization'">

    <button mat-stroked-button class="addButton" (click)="excelDownloadMaingridOrgPage()">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions
    *ngIf="selectedOption == 'Organization'">
    <button mat-stroked-button class="addButton" (click)="excelDownloadMaingridForMultiOrg()">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #excelPdfPopupOrgMain>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="excelDownloadMaingridOrg('user')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #excelPdfPopupOrgInd>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="excelDownloadMaingridOrg('training')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-editor #clobViewPopup></app-editor>


<ng-template #searchInstructorTraining>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchInstructorTrainingFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Search Instructor Training</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div id="filed-container" class="form-continer">
    <div class="row">
      <label for=" " style="color:red;" *ngIf="noUserAlert">Please select training</label>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div><label for="email">Training Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Training Name"
          [(ngModel)]="searchByInstructorTrainingName">
      </div>
      <div class="col-md-3">
        <div><label for="email">Version</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Version" [(ngModel)]="searchByVersion">
      </div>
      <div class="col-md-3">
        <div><label for="email">Trainer Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Trainer Name"
          [(ngModel)]="searchByTrainerName">
      </div>
      <div class="col-md-3">
        <div><label for="email">Training Mode</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Training Mode"
          [(ngModel)]="searchByTrainingMode">
      </div>
      <div class="col-md-3">
        <div><label for="email">Status</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Status" [(ngModel)]="searchByStatus">
      </div>
    </div>
    <div class="row">
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="searchInstructorTrainingGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchInstructorTrainingGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showInstructorTrainingSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">
          <div style="display: flex; justify-content: center; align-items: center;">
            <input id="selectAllTrainingCheckbox" type="checkbox" style="zoom: 1.2;"
              (change)="selectAllInsTrainings($event)">
          </div>
        </th>
        <th> <span>Training Name</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th> <span>Version</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th> <span>Trainer Name</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th> <span>Training Mode</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th> <span>Status</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container"
          *ngFor="let listOfUsersVwDetails of getTmsInstructorTrainingDetailsTableData; let idx = index;">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="listOfUsersVwDetails.searchTrainingChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2;"
                  [checked]="listOfUsersVwDetails.searchTrainingChildCheckBoxs"
                  (change)="searchInstructorTrainingChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.trainingName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.version }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.trainerName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.trainingMode }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.status }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showInstructorTrainingSearchGrid">
    <button mat-stroked-button class="addButton" (click)="addInstructorTrainingNameFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchInstructorTrainingFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #certificationPopup>
  <div class="ng-template-container" style="background-color: #f9f7f2;">
    <i class="fa fa-close pull-right" style="cursor: pointer;" title="Close" (click)="cancelCer()"
      (keydown.enter)="focusSearch('focus-Logo-search')"></i>
    <i class="fa fa-download pull-right" style="cursor: pointer;" title="Download" (click)="downloadAsPdf()"
      (keydown.enter)="focusSearch('focus-Logo-search')"></i>
    <div id="dataToExport" class="row" *ngIf="!isDefaultTemplate">
      <div class="col-md-10" style="margin-top: 2%;padding-left: 4%;margin-bottom: 2%;">
        <div class="row text-center">
          <span *ngIf="
                  oneQmsOrgImagesDetails != null ||
                  oneQmsOrgImagesDetails != undefined
                ">
            <img class="org-image" src="data:image/*;base64,{{ oneQmsOrgImagesDetails.logoImage }}" alt=""
              style="width: 60px; height: 60px" />
            <span style="display: inline-flex; width: 40%">{{
              orgData.orgLongName
              }}</span>
          </span>
        </div>
        <br />
        <div class="row text-center">
          <span class="cetificateTitle">Certificate of Completion</span>
        </div>
        <div class="row text-center" style="margin-top: 2%">
          <span style="color: gray; font-weight: 500"><i>This is to certify that</i></span>
        </div>
        <div class="row text-center" style="margin-top: 2%">
          <span style="font-weight: 600">{{ userDetails.firstName }}, {{ userDetails.lastName
            }}</span>
        </div>
        <div class="row text-center" style="margin-top: 2%">
          <span style="color: gray; font-weight: 500"><i>Has successfully completed the online
              course</i></span>
        </div>
        <div class="row text-center" style="margin-top: 2%">
          <span style="font-weight: 600">{{ trainingData.trainingName }}</span>
        </div>
        <div class="row text-center" style="margin-top: 2%"
          *ngIf="trainingData.finalScore!=null && trainingData.finalScore!=''">
          <span style="color: gray; font-weight: 500"><i>with score of {{ trainingData.finalScore }}%
              on</i></span>
        </div>
        <div class="row text-center" style="margin-top: 2%">
          <span style="font-weight: 600">{{
            trainingData.completedOn | date : "dd-MMM-yyyy"
            }}</span>
        </div>
        <hr style="border-top: 3px solid black" />
        <div class="row" *ngIf="isEsignRequired">
          <span style="color: gray; font-weight: 500"><i>{{ reasonForSign }} </i></span>
        </div>
        <div class="row" style="text-align: right; font-size: 11px; font-weight: 600">
          <span>{{ userDetails.firstName }}, {{ userDetails.lastName }}</span>
          <span>{{ userDetails.designation }}</span>
          <span>{{
            trainingData.completedOn | date : "dd-MMM-yyyy HH:mm:ss"
            }}</span>
          <span>I have read and understood training</span>
        </div>
      </div>
      <div class="col-md-2" style="
              height: auto;
              background-color: #f3caaf;
              width: 13%;
              margin-top: 2%;
              margin-bottom: 2%;
            "></div>
    </div>
    <div id="dataToExportFromTemp" *ngIf="isDefaultTemplate" [innerHTML]="certificateData"></div>
  </div>
</ng-template>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>



<ng-template #searchFoldersPopup>
  <div class="popup-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelSeachFoldersFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <app-folder-stucture [data]="'GROUPFOLDER'"
        (valueChange)="changeInFolderStructureChild($event)"></app-folder-stucture>
    </div>
    <div class="button-container">
      <div class="row">
        <h6 *ngIf="dmsGroupFoldersFieldData.folderName!=null">{{dmsGroupFoldersFieldData.folderName}}</h6>
      </div>
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="addFolderFunction()">
          <i class="fas fa-check"></i> Add
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelSeachFoldersFunction()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>